import React, { useState, useEffect, useCallback, useRef } from "react";
import SubLayout from "../../components/layout/SubLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Input,
  Button,
  Space,
  Typography,
  Popover,
  Checkbox,
  Divider,
  Radio,
  Modal,
  Select,
  Row,
  Col,
  Calendar,
  Avatar,
  message,
  Menu,
  InputNumber,
  DatePicker,
  Tooltip,
  Switch,
} from "antd";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  SearchOutlined,
  EyeInvisibleOutlined,
  FilterOutlined,
  EditOutlined,
  DeleteFilled,
  AppstoreAddOutlined,
  MenuOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  CopyOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import { Table, Badge, Tag, Dropdown } from "antd";
import {
  EyeOutlined,
  LeftOutlined,
  DownOutlined,
  InfoCircleOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  PercentageOutlined,
  CalendarOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import API_MANAGER from "../../API";
import { TransferModal } from "../../components/common/Mobilization/MobilizationTransferModal";
import AssignIcon from "../../Assets/assign.svg";
import { TransferPopover } from "../../components/common/Mobilization/MobilizationFilter";
import LoaderGif from "../../Assets/loader.gif";

import ShowHideColumnsPopover from "../../components/common/Mobilization/ShowHidePopover";

import YesIcon from "../../Assets/greentick.svg";
import NoIcon from "../../Assets/stop.svg";
import ArchiveIcon from "../../Assets/archive.svg"
import UnarchiveIcon from "../../Assets/unarchive.svg"

import NAIcon from "../../Assets/warning.svg";
import UserProfileCard from "../../components/common/Mobilization/ProfileCard";
import NoElement from "../../../src/Assets/campagin/no-campaign-image.svg";
import MobilzationPagination from "../../components/common/Mobilization/MobilizationPagination";
import MyIcon from "../../Assets/share.svg";
import DeleteModal from "../../components/common/Mobilization/DeleteProfile";
import YESNOICON from "../../Assets/yesnoicon.svg";
import moment from "moment";
import { current } from "@reduxjs/toolkit";
import ArchiveCandidates from "../../components/common/Mobilization/ArchiveCandidates";
import ArchiveConfirmModal from "../../components/common/Mobilization/ArchiveConfirmModal";
import { useMobilisationState } from "../../hooks/useGlobalState";
import { isPageStateExpired } from "../../utils/statePersistence";
import {
  downloadMobilisationExport,
  ensureSocketConnected,
  readExportPayload,
  waitForSocketConnected,
} from "../../components/Socket/socket";


const ENABLE_DEFAULT_GATES = true;
// const ENABLE_DEFAULT_GATES = false;

// Status Icons
const statusIcons = {
  success: <CheckCircleFilled style={{ color: "#10B981", fontSize: 18 }} />,
  warning: (
    <ExclamationCircleFilled style={{ color: "#FACC15", fontSize: 18 }} />
  ),
  error: <CloseCircleFilled style={{ color: "#EF4444", fontSize: 18 }} />,
};

// Function to handle column drag and drop

const options = [
  { label: "Calendar", icon: <CalendarOutlined /> },
  { label: "Pick List", icon: <OrderedListOutlined /> },
  {
    label: "Yes/No",
    icon: (
      <img
        src={YESNOICON}
        alt="edit"
        style={{
          width: 16,
          height: 16,
        }}
      />
    ),
  },
];


const columnData = [
  {
    category: "Personal Details",
    columns: [
      { key: "email", label: "Email", checked: true },
      { key: "photo", label: "Photo", checked: true },
      { key: "name", label: "Name", checked: true },
      { key: "dob", label: "DOB", checked: true },
      { key: "gender", label: "Gender", checked: true },
      { key: "ethnicity", label: "Ethnicity", checked: true },
      { key: "phone", label: "Phone Number", checked: true },
      { key: "nok", label: "Next-of-Kin", checked: true },
    ],
  },
  {
    category: "Location",
    columns: [{ key: "address", label: "Address", checked: true }],
  },
  {
    category: "Other Details",
    columns: [
      { key: "lsl", label: "LSL", checked: true },
      { key: "ppe", label: "PPE", checked: true },
      {
        key: "travel",
        label: "Travel - Preferred Airline and Frequent Flyer Number",
        checked: true,
      },
      { key: "police", label: "Police Clearance", checked: true },
      { key: "medical", label: "Medical", checked: true },
    ],
  },
  {
    category: "Recruitment",
    columns: [
      { key: "campaign_name", label: "Campaign Name", checked: true },
      { key: "project_code", label: "Project Code", checked: true },
      {
        key: "advert_name",
        label: "Advert Name (e.g., Job Title)",
        checked: true,
      },
      { key: "roster", label: "Roster", checked: true },
      { key: "employment_type", label: "Employment Type", checked: true },
      {
        key: "hard_compliance",
        label: "Hard Compliance Requirements",
        checked: true,
      },
      {
        key: "soft_compliance",
        label: "Soft Compliance Requirements",
        checked: true,
      },
      { key: "client_approval", label: "Client Approval", checked: true },
    ],
  },
  {
    category: "Manual Entries",
    columns: [
      {
        key: "manual_gate",
        label: "Manually Entered/Created Gate",
        checked: true,
      },
    ],
  },
];

function MobilisationManagement() {
  const location = useLocation();
  const [loadingTable, setLoadingTable] = useState(false);
  const [activeTab, setActiveTab] = useState("manual");
  const [activeAssing, setActiveAssign] = useState(false);
  const [activeLoader, setActiveLoader] = useState(false);

  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [isManual, setisManual] = useState(false);

  const [oldName, setOldName] = useState(undefined);
  const [deselectTrigger, setDeselectTrigger] = useState(false);

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);

  const handleNameChange = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setName(value);
      setShowTooltip(false);
    } else {
      setShowTooltip(true);
    }
  };

  const [search, setSearch] = useState(null);

  const [visibleFilter, setVisibleFilter] = useState(false);
  const [columnsvisible, setcolumnsvisible] = useState(columnData);
  const [visibleSort, setvisibleSort] = useState();
  // sortValue, selectedAdverts, isFilterUsing now come from Redux - see below
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filterDataAdvert, setfilterDataAdvert] = useState();
  const [columngatedata, setcolumngatedata] = useState();
  const [gateInfo, setgateInfo] = useState();
  const [togglerefresh, settogglerefresh] = useState();
  const [totalRecord, settotalRecord] = useState();
  // selectedAdverts, isFilterUsing, searchText, sortValue now come from Redux
  const calendarRef = useRef(null);

  const [numValues, setNumValues] = useState(1);

  const [values, setValues] = useState([""]);

  const handleChangePickLists = (index, newValue) => {
    const updatedValues = [...values];
    updatedValues[index] = newValue;
    setValues(updatedValues);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddGateModalOpen, setIsAddGateModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const [PopoverVisiblePickList, setPopoverVisiblePickList] = useState(false);

  const [YesNoValue, setYesNoValue] = useState();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState("false");
  const [dropdown, setdropdown] = useState(false);
  const [gateValue, setGateValue] = useState();

  const typeRef = useRef("Calendar");

  const { id } = useParams();
  const userType = localStorage.getItem("user");
  const [selectedType, setSelectedType] = useState("Calendar");

  const [previousType, setPreviousType] = useState();

  const tomorrow = dayjs().add(1, "day");

  const [transferModal, setTransferModal] = useState(false);
  const [onfilterPagination,setonFilterPagination]=useState(true);

  const [gateTemplates, setGateTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const gateTemplateSearchRef = useRef(null);

  const [defaultGates, setDefaultGates] = useState([]);
  const [savingDefaultGates, setSavingDefaultGates] = useState(false);
  const [allAutoGates, setAllAutoGates] = useState([]);
  const [isEditingDefaultGates, setIsEditingDefaultGates] = useState(false);
  const [tempSelectedAutoDefaults, setTempSelectedAutoDefaults] = useState([]);
  const [defaultGateConfirmType, setDefaultGateConfirmType] = useState(null);
  const isSavingDefaultGatesRef = useRef(false);
  const defaultGatesDirtyRef = useRef(false);
  const originalManualGateRef = useRef(null);

  const [defaultManualGate, setDefaultManualGate] = useState(null);
  const [savingDefaultManualGate, setSavingDefaultManualGate] = useState(false);

  const [isEditingDefaultTemplateList, setIsEditingDefaultTemplateList] = useState(false);
  const [defaultTemplateList, setDefaultTemplateList] = useState([]);
  const [allManualTemplates, setAllManualTemplates] = useState([]);
  const [tempSelectedDefaults, setTempSelectedDefaults] = useState([]);
  const [savingDefaultTemplateList, setSavingDefaultTemplateList] = useState(false);
  const [templateDropdownOpen, setTemplateDropdownOpen] = useState(false);
  const [templateSearchVal, setTemplateSearchVal] = useState("");

  const [manualDefaultModalOpen, setManualDefaultModalOpen] = useState(false);
  const [manualDefaultModalMode, setManualDefaultModalMode] = useState("set");
  const [manualDefaultTempSelected, setManualDefaultTempSelected] = useState([]);
  const [markAsDefaultOnCreate, setMarkAsDefaultOnCreate] = useState(false);

  const fetchDefaultGates = useCallback(async () => {
    try {
      const response = await API_MANAGER.getDefaultAutoGates();
      if (response?.data?.isSuccess) {
        const raw = response?.data?.data ?? [];
        const items = Array.isArray(raw) ? raw : [];
        const gatesWithIds = items.map((n) => {
          const gateName = typeof n === "string" ? n : n?.name || "";
          const gateKey = getGateKeyFromLabel(gateName.toLowerCase());
          return {
            _id: typeof n === "object" ? n?._id : null,
            name: gateName,
            key: gateKey,
          };
        }).filter((g) => g.key);
        setAllAutoGates(gatesWithIds);
        setDefaultGates(gatesWithIds.map((g) => g.key));
      }
    } catch {
      setAllAutoGates([]);
      setDefaultGates([]);
    }
  }, []);

  const fetchDefaultManualGate = useCallback(async () => {
    try {
      const response = await API_MANAGER.getDefaultManualGates();
      if (response?.data?.isSuccess && response?.data?.data) {
        setDefaultManualGate(response.data.data);
      } else {
        setDefaultManualGate(null);
      }
    } catch {
      setDefaultManualGate(null);
    }
  }, []);

  const fetchDefaultTemplateList = useCallback(async () => {
    try {
      const response = await API_MANAGER.getUniqueManualGates("");
      if (response?.data?.isSuccess && Array.isArray(response?.data?.data)) {
        const uniqueTemplates = response.data.data.map((item) => ({
          _id: item._id,
          name: item.name,
          type: normalizeGateType(item.type),
          rawType: item.type,
          category: item.category,
          values: Array.isArray(item.values) ? item.values : [],
          isDefault: !!item.isDefault,
          defaultGateId: item.defaultGateId || null,
        }));
        const defaults = uniqueTemplates.filter((t) => t.isDefault).map((t) => t.name);
        setAllManualTemplates(uniqueTemplates);
        setDefaultTemplateList(defaults);
        return { templates: uniqueTemplates, defaults };
      } else {
        setAllManualTemplates([]);
        setDefaultTemplateList([]);
        return { templates: [], defaults: [] };
      }
    } catch {
      setAllManualTemplates([]);
      setDefaultTemplateList([]);
      return { templates: [], defaults: [] };
    }
  }, []);

  const handleSaveDefaultTemplateList = async () => {
    setSavingDefaultTemplateList(true);
    try {
      const removedNames = defaultTemplateList.filter((name) => !tempSelectedDefaults.includes(name));
      const removedIds = allManualTemplates
        .filter((t) => removedNames.includes(t.name) && t._id)
        .map((t) => t._id);

      if (removedIds.length > 0) {
        await API_MANAGER.removeDefaultGates({ ids: removedIds });
      }

      const newDefaults = tempSelectedDefaults.filter((name) => !defaultTemplateList.includes(name));
      if (newDefaults.length > 0) {
        await API_MANAGER.setDefaultManualGates({ names: newDefaults });
      }

      message.success("Default list successfully saved.");
      defaultGatesDirtyRef.current = true;
      setDefaultTemplateList([...tempSelectedDefaults]);
      setAllManualTemplates((prev) =>
        prev.map((t) => ({ ...t, isDefault: tempSelectedDefaults.includes(t.name) }))
      );
      setIsEditingDefaultTemplateList(false);
    } catch {
      message.error("Failed to save default list.");
    } finally {
      setSavingDefaultTemplateList(false);
    }
  };

  const handleSetDefaultGates = async () => {
    if (isSavingDefaultGatesRef.current) {
      return;
    }
    isSavingDefaultGatesRef.current = true;
    setSavingDefaultGates(true);
    try {
      const normalizedDefaultKeys = defaultGates.map((k) => getGateKeyFromLabel(k));

      const finalSelected = [...new Set(tempSelectedAutoDefaults.map((k) => getGateKeyFromLabel(k)))];

      const removedKeys = normalizedDefaultKeys.filter((key) => !finalSelected.includes(key));
      const remove = [
        ...new Set(
          allAutoGates
            .filter((g) => removedKeys.includes(getGateKeyFromLabel(g.key)) && g._id)
            .map((g) => g._id)
        ),
      ];

      const newDefaults = finalSelected.filter((key) => !normalizedDefaultKeys.includes(key));
      const create = newDefaults.map((g) => (g === "next-of-kin" ? "nok" : g));

      if (create.length === 0 && remove.length === 0) {
        message.warning("No changes to save.");
        return;
      }

      await API_MANAGER.manageAutoDefaultGates({ create, remove });

      message.success("Default gates successfully saved.");
      defaultGatesDirtyRef.current = true;
      setDefaultGates([...finalSelected]);
      setIsEditingDefaultGates(false);
      setTempSelectedAutoDefaults([]);
      setSelectedGates([]);

      setTimeout(() => {
        fetchDefaultGates();
      }, 500);
    } catch {
      message.error("Failed to save default gates.");
    } finally {
      setSavingDefaultGates(false);
      isSavingDefaultGatesRef.current = false;
    }
  };

  const handleSetDefaultManualGate = async () => {
    setSavingDefaultManualGate(true);
    try {
      let resolvedValues;
      if (selectedType === "Pick List") {
        resolvedValues = (values || []).filter((v) => v !== "");
      } else if (selectedType === "Yes/No") {
        resolvedValues = [YesNoValue || "yes"];
      } else {
        resolvedValues = selectedDate ? [selectedDate] : [];
      }
      const payload = {
        name: name,
        type: (selectedType || "").toLowerCase(),
        category: selectedCategory || "personal details",
        values: resolvedValues,
      };
      await API_MANAGER.setDefaultManualGates(payload);
      message.success("Default gate successfully saved.");
      defaultGatesDirtyRef.current = true;
      setDefaultManualGate(payload);
    } catch {
      message.error("Failed to save default gate.");
    } finally {
      setSavingDefaultManualGate(false);
    }
  };

  const normalizeGateType = (type) => {
    if (!type) return "Yes/No";
    const lower = type.toLowerCase().trim();
    if (lower === "pick list") return "Pick List";
    if (lower === "calendar") return "Calendar";
    return "Yes/No";
  };

  const fetchGateTemplates = useCallback(async (searchVal = "") => {
    setLoadingTemplates(true);
    try {
      const response = await API_MANAGER.getUniqueManualGates(searchVal);
      if (response?.data?.isSuccess && Array.isArray(response?.data?.data)) {
        setGateTemplates(
          response.data.data.map((item) => ({
            _id: item._id,
            name: item.name,
            type: normalizeGateType(item.type),
          }))
        );
      } else {
        setGateTemplates([]);
      }
    } catch {
      setGateTemplates([]);
    } finally {
      setLoadingTemplates(false);
    }
  }, []);

  const [candidateSelectedData, setCandidateSelectedData] = useState({});
  const [oldAdvertId, setOldAdvertId] = useState("");
  const [sortType, setSortType] = useState("-createdAt");
  // const [search, setSearch] = useState("");
  console.log(location.state?.currentPage,"LOCATION VALUEEE")
  const { 
    pageState, 
    updateCurrentPage, 
    updateSearchText,
    updateSortValue,
    updateSelectedItems,
    updateIsFilterUsing,
    updateCustomFilter,
    updateCustomFilters,
    resetPage
  } = useMobilisationState();
  
  const currentPage = pageState.currentPage || 1;
  const setCurrentPage = (page) => updateCurrentPage(page);
  
  // Get filter states from Redux
  const searchText = pageState.searchText || "";
  const sortValue = pageState.sortValue || "recentlyAdded";
  const selectedAdverts = pageState.selectedItems || [];
  const isFilterUsing = pageState.isFilterUsing || false;
  const badgeIds = pageState.customFilters?.badgeIds || [];
  
  // Setters that update Redux
  const setSearchText = (value) => {
    console.log("Setting searchText in Redux:", value);
    updateSearchText(value);
  };
  const setSortValue = (value) => {
    console.log("Setting sortValue in Redux:", value);
    updateSortValue(value);
  };
  const setSelectedAdverts = (value) => {
    console.log("Setting selectedAdverts in Redux:", value?.length || 0, "advert IDs", value?.slice(0, 5) || 'none');
    updateSelectedItems(value);
  };
  const setIsFilterUsingState = (value) => {
    console.log("Setting isFilterUsing in Redux:", value);
    updateIsFilterUsing(value);
  };
  const setbadgeIds = (value) => {
    console.log("Setting badgeIds in Redux:", value?.length || 0);
    updateCustomFilter('badgeIds', value);
  };
  
  // Debug: Log filter state from Redux
  console.log("Filter state from Redux:", { 
    selectedAdvertsCount: selectedAdverts?.length || 0, 
    selectedAdverts: selectedAdverts?.slice(0, 5) || 'none', // First 5 IDs
    searchText, 
    sortValue, 
    isFilterUsing, 
    badgeIdsCount: badgeIds?.length || 0, 
    currentPage 
  });

  const [profileId, setProfileId] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [reloadState, setReloadState] = useState(false);
  const [transferData, setTransferData] = useState([]);
  const [mobilzationColumn, setmobilzationColumn] = useState();

  const [colGateId, setcolGateId] = useState();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const [isVisible, setIsVisible] = useState(false);

  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);

  const [hidecolumn, sethidecolumn] = useState([]);
  const [hideRow, sethideRow] = useState([]);
  const [prefilledarray, setprefilledarray] = useState([]);

  const [archiveModalVisible, setArchiveModalVisible] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [archiveMode, setArchiveMode] = useState("archive");
  const [archiveTargetIds, setArchiveTargetIds] = useState([]);

  const [prevGateName, setPrevGateName] = useState([]);

  const [advertSearch, setAdvertSearch] = useState("");
  const [advertIds, setadvertIds] = useState([]);

  // badgeIds now comes from Redux - see above

  const [filterDataUser, setfilterDataUser] = useState();
  const [refreshToggle, setRefreshToggle] = useState(false);
  const datePickerRef = useRef(null);
  const [isArchiveView, setIsArchiveView] = useState(false);
  const [exportingGates, setExportingGates] = useState(false);
  const exportingGatesRef = useRef(false);
  const exportTimeoutRef = useRef(null);

  const noDragKeys = ["details", "campaign-advert"];

  const handleToggle = () => {
    setRefreshToggle((prev) => !prev);
  };

  const [rowID, setrowID] = useState();

  const [rowuserName, setrowuserName] = useState();

  const [data, setData] = useState([]);

  const pagination = data.length;

  const firstDetail = data?.length > 0 ? data[0] : null;

  const [selectedOption, setSelectedOption] = useState("");
  const [date, setdate] = useState(null);
  const noUnderlineKeys = [
    "name",
    "dob",
    "ethnicity",
    "phone number",
    "lsl",
    "ppe",
    "travel",
    "project code",
    "roster",
    "employment type",
    "hard requirments",
    "soft requirments",
    "client approval",
    "medical",
    "details",
    "campaign-advert",
    "usi number",
    "address",
    "gender",
    "nok",
  ];

  const handleSelectChange = (e, gateId) => {
    setdate(e.target.value);
    // setSelectedOption(e.target.value);
    setSelectedOption((prev) => ({
      ...prev,
      [gateId]: e.target.value,
    }));

    UpdateMannualPopulatedGates(e.target.value, gateId, null);
  };

  // useEffect(() => {
  //   console.log("Updated selectedOption:", selectedOption);
  // }, [selectedOption]);

  // Restore currentPage and filter states from location.state when navigating back
  useEffect(() => {
    if (location.state) {
      // Restore pagination
      if (location.state.currentPage) {
        setCurrentPage(location.state.currentPage);
      }
      
      // Restore filter states
      if (location.state.filterState) {
        const filterState = location.state.filterState;
        
        // Restore selected adverts (most important filter)
        if (filterState.selectedItems && filterState.selectedItems.length > 0) {
          setSelectedAdverts(filterState.selectedItems);
          // Sync badgeIds with selectedItems if they exist
          if (!filterState.badgeIds || filterState.badgeIds.length === 0) {
            setbadgeIds(filterState.selectedItems);
          }
        }
        
        // Restore badge IDs (if provided separately)
        if (filterState.badgeIds && filterState.badgeIds.length > 0) {
          setbadgeIds(filterState.badgeIds);
        }
        
        // Restore search text
        if (filterState.searchText !== undefined) {
          setSearchText(filterState.searchText);
        }
        
        // Restore sort value
        if (filterState.sortValue) {
          setSortValue(filterState.sortValue);
        }
        
        // Restore filter using flag (should be set after all filters are restored)
        if (filterState.isFilterUsing !== undefined) {
          setIsFilterUsingState(filterState.isFilterUsing);
        } else if (filterState.selectedItems?.length > 0 || filterState.searchText) {
          // Auto-set filter flag if we have filters
          setIsFilterUsingState(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.currentPage, location.state?.filterState]);
  const { Option } = Select;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setPopoverVisible(false);
      }
    };

    if (popoverVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popoverVisible]);

  const iconOptions = {
    no: {
      icon: <img src={NoIcon} alt="Yes" style={{ width: 18, height: 18 }} />,
      label: "No",
    },
    wip: {
      icon: <img src={NAIcon} alt="Yes" style={{ width: 18, height: 18 }} />,
      label: "WIP",
    },
    yes: {
      icon: <img src={YesIcon} alt="Yes" style={{ width: 18, height: 18 }} />,
      label: "Yes",
    },
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => message.success("Copied to clipboard."))
      .catch(() => message.error("Failed to copy ."));
  };

  const advertIdsfinal = transferData.flatMap(
    (item) => item.adverts?.map((ad) => ad._id) || []
  );

  useEffect(() => {
    if (!filterDataUser) return;

    const transformedData = filterDataUser.map((entry, index) => {
      const userInfo =
        Array.isArray(entry) && entry.length > 0 ? entry[0] : null;

      const gates = entry.slice(1);

      // Extract gate information dynamically
      const gateData = gates?.reduce((acc, gate) => {
        const rawDate = gate?.dataIndex;

        let formattedDate = "N/A";
        console.log(gates.gate, "GGGG");

        if (rawDate?.length > 0) {
          // const parsedDate = moment(
          //   rawDate,
          //   ["MM-DD-YYYY", "YYYY-MM-DD", "DD-MM-YYYY"],
          //   true
          // );
          // if (parsedDate.isValid()) {
          //   formattedDate = parsedDate.format("DD-MM-YYYY");
          // }
          formattedDate = moment(rawDate)?.format("DD MMM YYYY");
        }

        acc[gate?.gate] = {
          value:
            gate?.gate === "dob"
              ? formattedDate
              : gate?.gate === "ppe"
              ? gate?.dataIndex || {}
              : gate?.dataIndex !== null && gate?.dataIndex !== undefined
              ? gate?.dataIndex
              : "",

          creationType: gate?.creationType || "auto",
          values: gate?.values || [],
          gateId: gate?.gateId,
          type: gate?.type || "N/A",
        };

        return acc;
      }, {});

      setgateInfo(entry);
      console.log(gateData, "gateData");
      const mappedData = mobilzationColumn.reduce((acc, { dataIndex }) => {
        const gate = gateData[dataIndex];
        let value = gate?.value;
        const creationType = gate?.creationType;
        const gateId = gate?.gateId;
        const type = gate?.type || "N/A";
        const options = gate?.values || [];
        if (creationType === "manual") {
          const inputStyle = {
            padding: "2px 6px",
            borderRadius: "4px",
            fontSize: "15px",
            width: "100%",
            maxWidth: "160px",
            border: "1px solid #ccc",
            backgroundColor: "#fdfdfd",
          };

          const initialValue = selectedOption[gateId] ?? value ?? "";

          switch (type) {
            // case "calendar":
            //   const dateOnly =
            //     typeof value === "string" ? value.split("T")[0] : "";
            //   value = (
            //     <input
            //       type="date"
            //       // placeholder={selectedOption[gateId] ?? dateOnly}
            //       value={selectedOption[gateId] ?? dateOnly}
            //       onChange={(e) =>
            //         handleSelectChange(
            //           { target: { value: e.target.value } },
            //           gateId
            //         )
            //       }
            //       style={inputStyle}
            //     />
            //   );
            //   break;

            case "calendar":
              const dateOnly = options[0];
              const initialDate = dayjs(dateOnly);
              // const displayDate = ;

              console.log(dateOnly, "DDD");

              const formattedDate = new Date(dateOnly).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }
              );

              const defaultDate = dayjs(formattedDate, "DD MMM YYYY");

              const selectedStatus = selectedOption?.[gateId] ?? "yes";

              value = (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {/* <span
                    style={{
                      color: "#1E293B",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {formattedDate}
                  </span> */}

                  <DatePicker
                    className="custom-datepicker"
                    size="small"
                    allowClear={false}
                    placeholder={
                      formattedDate === "Invalid Date" ? " " : formattedDate
                    }
                    initialValue={
                      formattedDate === "Invalid Date"
                        ? null
                        : dayjs(formattedDate, "DD MMM YYYY")
                    }
                    format="DD MMM YYYY"
                    // disabledDate={(current) =>
                    //   current && current.isBefore(tomorrow, "day")
                    // }

                    onChange={(date, dateString) => {
                      setUpdateDate(dateString);
                      UpdateMannualPopulatedGates(null, gateId, dateString);
                    }}
                  />
                  {/* <h1>{formattedDate}</h1>
                     {console.log(formattedDate,"XMENDEBUG1")} */}

                  <Select
                    key={gateId}
                    value={selectedOption[gateId] ?? initialValue ?? undefined}
                    onChange={(value) =>
                      handleSelectChange({ target: { value } }, gateId)
                    }
                    style={{ width: 61 }}
                  >
                    {!selectedOption[gateId] && !initialValue ? (
                      <Option value={""} disabled hidden>
                        {""}
                      </Option>
                    ) : null}

                    {Object.entries(iconOptions).map(
                      ([key, { icon, label }]) => (
                        <Option key={key} value={key}>
                          {icon}
                        </Option>
                      )
                    )}
                  </Select>
                </div>
              );
              break;

            case "pick list":
              value = (
                <Select
                  key={gateId}
                  value={
                    (selectedOption[gateId] ?? initialValue ?? "") || undefined
                  }
                  onChange={(value) =>
                    handleSelectChange({ target: { value } }, gateId)
                  }
                  style={{ width: 120 }}
                >
                  <Option value="" disabled hidden>
                    <span style={{ fontSize: "14px" }}>
                      {initialValue === "wip"
                        ? initialValue.toUpperCase()
                        : initialValue?.charAt(0).toUpperCase() +
                          initialValue?.slice(1).toLowerCase()}
                    </span>
                  </Option>

                  {options.map((opt, idx) => (
                    <Option key={idx} value={opt} style={{ fontSize: "14px" }}>
                      {opt}
                    </Option>
                  ))}
                </Select>
              );
              break;

            case "yes/no":
              value = (
                <Select
                  key={gateId}
                  value={selectedOption[gateId] ?? initialValue ?? undefined}
                  onChange={(value) =>
                    handleSelectChange({ target: { value } }, gateId)
                  }
                  style={{ width: 100 }}
                >
                  <Option value="" disabled hidden>
                    <div style={{ display: "flex" }}>
                      <span style={{ marginTop: "-2px", paddingRight: "3px" }}>
                        {iconOptions[initialValue]?.icon}{" "}
                      </span>
                      <span>
                        {initialValue === "wip"
                          ? initialValue.toUpperCase()
                          : initialValue.charAt(0).toUpperCase() +
                            initialValue.slice(1).toLowerCase()}
                      </span>
                    </div>
                  </Option>
                  {Object.entries(iconOptions).map(([key, { icon, label }]) => (
                    <Option key={key} value={key}>
                      {icon} <span style={{ marginLeft: 8 }}>{label}</span>
                    </Option>
                  ))}
                </Select>
              );
              break;

            default:
              value = (
                <span style={{ fontSize: "12px", color: "#888" }}>
                  Invalid Type
                </span>
              );
          }
        } else {
          if (Array.isArray(value)) {
            const headers = Object.keys(value?.[0] || {}).map((header) => {
              if (header === "memberNumber") return "No.";
              if (header === "state") return "State";
              return header;
            });

            value = (
              <div
                style={{
                  overflowX: "auto",
                  maxWidth: "180px",
                  minWidth: "140px",
                  border: "1px solid #eee",
                  borderRadius: "4px",
                  padding: "4px",
                  background: "#fafafa",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                    tableLayout: "fixed",
                  }}
                >
                  <thead>
                    <tr>
                      {headers.map((header) => (
                        <th
                          key={header}
                          style={{
                            borderBottom: "1px solid #ddd",
                            padding: "2px 4px",
                            background: "#f0f0f0",
                            whiteSpace: "nowrap",
                            textAlign: "left",
                          }}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {value.map((row, index) => (
                      <tr key={index}>
                        {Object.entries(row).map(([key, cell], i) => {
                          let displayValue = cell;

                          // For 'state', extract short form in brackets
                          if (key === "state" && typeof cell === "string") {
                            const match = cell.match(/\(([^)]+)\)/);
                            displayValue = match ? match[1] : cell;
                          }

                          return (
                            <td
                              key={i}
                              style={{
                                padding: "2px 4px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {displayValue || "-"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          } else if (typeof value === "object" && value !== null) {
            value =
              value && Object.keys(value).length > 0 ? (
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "10px",
                    display: "inline-block",
                    fontSize: "12px",
                    background: "#f9f9f9",
                    textAlign: "left",
                    minWidth: "100%",
                  }}
                >
                  {Object.entries(value)
                    .filter(
                      ([_, v]) => v !== null && v !== undefined && v !== ""
                    )
                    .map(([label, val]) => (
                      <div
                        key={label}
                        style={{
                          marginBottom: "8px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            minWidth: "50px",
                            fontSize: "14px",
                          }}
                        >
                          {label.charAt(0).toUpperCase() + label.slice(1)}
                        </span>
                        <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                          {val}
                        </span>
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={NoIcon} alt="No" width="20" height="20" />
                </div>
              );
          } else if (typeof value === "boolean") {
            value = value ? "Yes" : "No";
          } else if (value === "pending") {
            value = "N/A";
          } else {
            value = value || (
              <Tooltip title="Gate isn't assigned to this advert." arrow>
                <p
                  style={{
                    margin: 0,
                    fontSize: "17px",
                    display: "inline-block",
                  }}
                >
                  &#8709;
                </p>
              </Tooltip>
            );
          }
        }

        acc[dataIndex] = value;
        return acc;
      }, {});

      const formattedDataGate = mobilzationColumn?.reduce(
        (acc, { dataIndex }) => {
          acc[dataIndex] = ["photo", "name"].includes(dataIndex)
            ? "N/A"
            : false;
          return acc;
        },
        {}
      );
      setcolumngatedata(formattedDataGate);

      return {
        key: (index + 1).toString(),
        advertIds: userInfo.advertId,
        startDate: userInfo.startDate,
        endDate: userInfo.endDate,
        jobTitle: userInfo.jobTitle,
        userName: userInfo?.userName,
        email: userInfo?.email,
        // dob: moment(userInfo?.dob).format("DD MMM YYYY"),
        phoneNumber: userInfo?.phoneNumber,
        availability: userInfo?.availability,
        photo: userInfo?.photo,
        jobId: userInfo?.jobId,
        candidateId: userInfo?.candidateId,
        userId: userInfo?.userId,

        ...mappedData,
      };
    });

    setData(transformedData);
  }, [filterDataUser, refreshToggle, selectedOption, mobilzationColumn]);

  const [selectedGates, setSelectedGates] = useState([]);

  const hasRestoredFiltersRef = useRef(false);
  
  useEffect(() => {
    if (hasRestoredFiltersRef.current) return;
    hasRestoredFiltersRef.current = true;

    if (isPageStateExpired('mobilisationManagement', 60000)) {
      resetPage();
      localStorage.setItem("applyTrigger", "true");
      return;
    }

    const savedSelectedAdverts = pageState?.selectedItems || [];
    const savedSearchText = pageState?.searchText || "";
    const savedSortValue = pageState?.sortValue || "recentlyAdded";
    const savedCurrentPage = pageState?.currentPage || 1;
    const savedBadgeIds = pageState?.customFilters?.badgeIds || [];

    if (savedCurrentPage === 1 && savedSelectedAdverts.length === 0 && !savedSearchText) {
      localStorage.setItem("applyTrigger", "true");
      return;
    }

    if (savedSelectedAdverts.length > 0 || savedSearchText) {
      if (savedSelectedAdverts.length > 0) {
        setSelectedAdverts([...savedSelectedAdverts]);
      }

      if (savedBadgeIds.length > 0) {
        setbadgeIds(savedBadgeIds);
      } else if (savedSelectedAdverts.length > 0) {
        setbadgeIds([...savedSelectedAdverts]);
      }

      if (savedSearchText) {
        setSearchText(savedSearchText);
      }
      if (savedSortValue && savedSortValue !== "recentlyAdded") {
        setSortValue(savedSortValue);
      }

      localStorage.setItem("restoreFilters", "true");
      localStorage.setItem("restoreSelectedAdverts", JSON.stringify(savedSelectedAdverts));
      setIsFilterUsingState(true);
    }
  }, []);

  // Map display labels to actual gate keys
  const getGateKeyFromLabel = (label) => {
    const labelToKeyMap = {
      "next-of-kin": "nok",
      "phone number": "phone",
    };
    return labelToKeyMap[label] || label;
  };

  const handleCheckboxChange = (value) => {
    const gateKey = getGateKeyFromLabel(value);
    
    if (isEditingDefaultGates) {
      setTempSelectedAutoDefaults((prev) =>
        prev.includes(gateKey)
          ? prev.filter((item) => item !== gateKey)
          : [...prev, gateKey]
      );
    } else {
      setSelectedGates((prevSelected) =>
        prevSelected.includes(gateKey)
          ? prevSelected.filter((item) => item !== gateKey)
          : [...prevSelected, gateKey]
      );
    }
  };

  const getCandidateDetails = async () => {
    setLoading(true);
    const param = {
      page: currentPage,
      limit: 10,
      sort: sortType,
      search: search,
    };
    try {
      const response = await API_MANAGER.getAdvertCandidatesDetail(id, param);

      setReloadState(false);
      // setCandidatesDetails(response?.data?.data);
      setOldAdvertId(response?.data?.data?.result[0]?.advertId?._id);
      setProfileId(response?.data?.data?.result[0]?.profileId?._id);
      setCandidateName(response?.data?.data?.result[0]?.candidateName);
    } catch (error) {
      // message.error("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  const getAdvertData = async (id) => {
    setLoading(true);
    // let params = {
    //   page: 1,
    //   limit: 100,
    //   sort: "-createdAt",
    // };
    let params = {
      profileId: candidateSelectedData?.profileId?._id,
      sort: "-createdAt",
      limit: 20000,
      page: 1,
    };
    if (advertSearch) {
      params = { ...params, ["search"]: advertSearch };
    }
    if (userType !== "Associate") {
      try {
        const response = await API_MANAGER.getSingleUserCampaignDetailsAll(
          params
        );
        setTransferData(response?.data?.data);
      } catch (error) {
        message.error("Something went wrong. Please try again.");
      }
    }
    setLoading(false);
  };
  useEffect(() => {
    getAdvertData();
  }, [advertSearch]);

  useEffect(() => {
    getCandidateDetails();
  }, [search, sortType, currentPage, id, reloadState == true]);

  const onClose = () => {
    setPopoverVisiblePickList(false);
  };

  const [selectedDate, setSelectedDate] = useState(tomorrow);

  // Handle click event
  const handleDateClick = (date) => {
    // alert(data);

    const formattedDate = dayjs(date);
    setSelectedDate(formattedDate);
    setPopoverVisible(false);
  };

  const [updateDate, setUpdateDate] = useState();

  // const [typeMannual, settypeMannual] = useState();

  // searchText now comes from Redux - see above

  // const handleSearchChange = (e) => {

  //   setSearchText(e.target.value);

  // };
  useEffect(() => {}, [advertIds]);

  useEffect(() => {
    if (isAddGateModalOpen) {
      fetchDefaultGates();
      fetchDefaultManualGate();
      fetchDefaultTemplateList();
    }
  }, [isAddGateModalOpen, fetchDefaultGates, fetchDefaultManualGate, fetchDefaultTemplateList]);

  const handleprefilled = (prefilledname) => {
    originalManualGateRef.current = null;
    filterDataUser.map((user) => {
      user.map((gate) => {
        if (gate.gate === prefilledname) {
          setcolGateId(gate?.gateId);
        }
        if (gate?.type === "calendar" && gate.gate === prefilledname) {
          setSelectedType("Calendar");
          setPreviousType("Calendar");

          setSelectedDate(dayjs(gate?.values));
          originalManualGateRef.current = {
            name: prefilledname,
            type: "Calendar",
            values: gate?.values,
          };
        } else if (gate?.type === "pick list" && gate.gate === prefilledname) {
          setSelectedType("Pick List");
          setPreviousType("Pick List");

          setValues(gate?.values);
          originalManualGateRef.current = {
            name: prefilledname,
            type: "Pick List",
            values: gate?.values,
          };
        } else if (gate?.type === "yes/no" && gate.gate === prefilledname) {
          setSelectedType("Yes/No");
          setPreviousType("Yes/No");
          setYesNoValue(gate?.values);
          originalManualGateRef.current = {
            name: prefilledname,
            type: "Yes/No",
            values: gate?.values,
          };
        }
      });
    });
  };
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.focus();
    }
  };

  function attachClickListenerToAntPickerInput(callback) {
    const pickerInput = document.querySelector(".ant-picker-input");

    if (pickerInput) {
      //  alert("YES")
      pickerInput.addEventListener("click", callback);
    } else {
      console.warn('Element with class "ant-picker-input" not found.');
    }
  }

  const handleButtonClick = (label) => {
    typeRef.current = label;
    setSelectedType(label);
    if (label === "Calendar") {
      attachClickListenerToAntPickerInput();
      openDatePicker();
      setPopoverVisible(!popoverVisible);
    }
    if (label === "Pick List") {
      setPopoverVisiblePickList(true);
      setDropdownVisible(true);
    }
    if (label === "Yes/No") {
      setdropdown(!dropdown);
    }
  };

  // Render date cells with popover
  const dateCellRender = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
  };

  const openAddGateModal = async () => {
    defaultGatesDirtyRef.current = false;
    setadvertIds([]);
    setPreviousType();
    setValues([""]);
    setYesNoValue();
    setSelectedCategory();
    setSelectedType();
    setName();
    setOldName("");
    setActiveAssign(false);
    setOldName("");
    setName("");
    setIsUpdateMode(false);
    setisManual(false);
    setIsAddGateModalOpen(false);
    setprefilledarray([]);
    try {
      const response = await API_MANAGER.getDefaultAutoGates();
      if (response?.data?.isSuccess) {
        const raw = response?.data?.data ?? [];
        const items = Array.isArray(raw) ? raw : [];
        const names = items
          .map((n) => {
            const gateName = typeof n === "string" ? n : n?.name || "";
            return getGateKeyFromLabel(gateName.toLowerCase());
          })
          .filter(Boolean);
        setDefaultGates(names);
      } else {
        setDefaultGates([]);
      }
    } catch {
      setDefaultGates([]);
    }
    setIsAddGateModalOpen(true);
  };

  const closeAddGateModal = () => {
    setadvertIds([]);
    setPopoverVisible(false);
    // setSelectedDate();
    setValues([""]);
    setYesNoValue();
    setSelectedCategory();
    setSelectedType();
    setName();
    setOldName("");
    setSelectedGates([]);
    setOldName("");
    setName("");
    setIsUpdateMode(false);
    setisManual(false);
    setDefaultGates([]);
    setDefaultManualGate(null);
    setIsEditingDefaultTemplateList(false);
    setDefaultTemplateList([]);
    setAllManualTemplates([]);
    setTempSelectedDefaults([]);
    setTemplateDropdownOpen(false);
    setTemplateSearchVal("");
    setDefaultGateConfirmType(null);
    setManualDefaultModalOpen(false);
    setManualDefaultTempSelected([]);
    setMarkAsDefaultOnCreate(false);
    setIsAddGateModalOpen(false);
    if (defaultGatesDirtyRef.current) {
      defaultGatesDirtyRef.current = false;
      handleToggle();
    }
  };

  const closeManualDefaultModal = () => {
    setManualDefaultModalOpen(false);
    setManualDefaultTempSelected([]);
    if (defaultGatesDirtyRef.current) {
      defaultGatesDirtyRef.current = false;
      handleToggle();
    }
  };

  const buildManualGatePayload = (tpl) => {
    const rawType = (tpl.rawType || tpl.type || "").toLowerCase();
    const normalizedType = rawType === "pick list" ? "pick list"
      : rawType === "calendar" ? "calendar"
      : "yes/no";
    let values = Array.isArray(tpl.values) ? tpl.values.filter((v) => v !== "") : [];
    if (values.length === 0) {
      if (normalizedType === "yes/no") values = ["yes"];
      else values = [];
    }
    return {
      name: tpl.name,
      type: normalizedType,
      category: tpl.category || "personal details",
      values,
    };
  };

  const handleSaveManualDefaultModal = async () => {
    setSavingDefaultTemplateList(true);
    try {
      const newDefaults = manualDefaultTempSelected.filter((n) => !defaultTemplateList.includes(n));
      const removedNames = defaultTemplateList.filter((n) => !manualDefaultTempSelected.includes(n));

      const create = allManualTemplates
        .filter((t) => newDefaults.includes(t.name) && t._id)
        .map((t) => t._id);

      const remove = allManualTemplates
        .filter((t) => removedNames.includes(t.name) && t.defaultGateId)
        .map((t) => t.defaultGateId);

      if (create.length === 0 && remove.length === 0) {
        setSavingDefaultTemplateList(false);
        return;
      }

      await API_MANAGER.manageManualDefaultGates({ create, remove });

      defaultGatesDirtyRef.current = true;
      message.success("Default gates successfully updated.");
      await fetchDefaultTemplateList();
      closeManualDefaultModal();
    } catch {
      message.error("Failed to save default list.");
    } finally {
      setSavingDefaultTemplateList(false);
    }
  };

  const handleConfirmDefaultGateAction = async () => {
    const type = defaultGateConfirmType;
    setDefaultGateConfirmType(null);
    if (!type) return;
    await handleSetDefaultGates();
  };

  const handelEyeClick = (jobId) => {
    sethideRow((prev) => {
      if (!prev.includes(jobId)) {
        return [...prev, jobId];
      }
      return prev;
    });
  };

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  // const handleOk = () => {
  //   setIsModalVisible(false);
  //  // Perform delete action here
  // };

  const handleSortChange = (e) => {
    setSortValue(e.target.value);
    setvisibleSort(false);
  };

  const [checkedKeys, setCheckedKeys] = useState([]);

  const contentSort = (
    <div
      style={{ width: 180, background: "#fff", padding: 12, borderRadius: 8 }}
    >
      <h4
        style={{
          fontSize: 14,
          fontWeight: 600,
          marginBottom: 10,
          color: "black",
        }}
      >
        SORT LIST
      </h4>
      <Radio.Group
        onChange={handleSortChange}
        value={sortValue}
        style={{ display: "flex", flexDirection: "column", gap: 6 }}
      >
        <Radio value="recentlyAdded" style={{ fontSize: 13 }}>
          Recently Added
        </Radio>
        <Radio value="alphabetical" style={{ fontSize: 13 }}>
          Alphabetical
        </Radio>
        {/* <Radio value="asc" style={{ fontSize: 13 }}>
         Ascending
        </Radio>
          <Radio value="des" style={{ fontSize: 13 }}>
         Decending
        </Radio> */}
      </Radio.Group>
    </div>
  );

  const handleCheck = (key) => {
    setCheckedKeys((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    );
  };
  const renderTree = (items, level = 0) =>
    items.map((item) => (
      <div
        key={item.key}
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: level * 15, // Controls indentation
          paddingBottom: 5,
        }}
      >
        {item.children ? (
          <DownOutlined style={{ fontSize: 12, marginRight: 5 }} />
        ) : (
          <span style={{ width: 17 }} /> // Keeps alignment consistent for all rows
        )}
        <Checkbox
          checked={checkedKeys.includes(item.key)}
          onChange={() => handleCheck(item.key)}
          style={{ fontSize: 14 }}
        >
          {item.label}
        </Checkbox>
      </div>
    ));

  const toggleVisibility = (key) => {
    setcolumnsvisible((prev) =>
      prev.map((section) => ({
        ...section,
        columnsvisible: section.columnsvisible.map((col) =>
          col.key === key ? { ...col, checked: !col.checked } : col
        ),
      }))
    );
  };

  //API

  const handelAdvertofGates = async (gatename) => {
    try {
      // Map UI gate name to API expected value
      const apiGateName = gatename === "next-of-kin" ? "nok" : gatename;
      const data = {
        gateNames: [apiGateName],
      };

      const response = await API_MANAGER.getadvertsOfGates(data);
      setprefilledarray(response?.data?.data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const assignGates = async () => {
    // console.log(prefilledarray, advertIds, "TIOP");
    // const newadvert = [];
    // for (const ids of advertIds) {
    //   if (!prefilledarray.includes(ids)) {
    //     newadvert.push(ids);
    //   }
    // }
    try {
      const data = {
        adverts: advertIds,
        gates: [colGateId],
      };

      const response = await API_MANAGER.assignGates(data);
      // setGateValue(response?.data?.data?.gateValue);
      // console.log(response?.data?.data?.gateValue, "TEST RESP");

      if (response?.status === 200 || response?.status === 409) {
        message.success("Gate(s) successfully assigned/unassigned.");
        // setVisible(false);

        handleToggle();
        setcolGateId();
        setActiveAssign(false);
        // setActiveTab();
        setIsAddGateModalOpen(false);
        // setIsAddGateModalOpen(false);
      } else {
        handleToggle();
        setcolGateId();
        setActiveAssign(false);
        // setActiveTab();
        setIsAddGateModalOpen(false);
        // message.error(JSON.stringify(response?.data?.message, null, 2));
        // setSelectedColumns();
      }
    } catch (error) {
      message.error("Gate(s) already assigned, to the advert(s).");
      handleToggle();
      setActiveAssign(false);
      setcolGateId();
      // setActiveTab();
      setIsAddGateModalOpen(false);

      // setSelectedColumns();
    }
  };

  const updateFullMannualGate = async () => {
    let filteredValues;
    if (selectedType === "Pick List") {
      filteredValues = values.filter((value) => value !== "");
      setValues(filteredValues);
    }

    let update = {
      type: selectedType.toLowerCase(),
      name: name,
    };

    if (selectedType === "Calendar" && previousType === "Calendar") {
    } else {
      update.values =
        selectedType === "Pick List"
          ? filteredValues
          : selectedType === "Yes/No"
          ? YesNoValue || ["yes"]
          : [selectedDate];
    }

    // else {
    //   update.gateValue=null;
    // }

    const Data = {
      oldName: oldName,
      adverts: advertIds,
      update: update,
    };

    try {
      const response = await API_MANAGER.updateManualGateAll(Data);

      if (response?.status === 200) {
        message.success("Gate(s) successfully updated.");
        
        // Update column order ref and localStorage when gate name changes
        // This ensures the column stays in the same position after rename
        if (columnOrderRef.current && oldName && name && oldName !== name) {
          const updatedOrder = columnOrderRef.current.map(key => 
            key === oldName ? name : key
          );
          columnOrderRef.current = updatedOrder;
          localStorage.setItem("columnOrder", JSON.stringify(updatedOrder));
          console.log("📋 Updated column order after rename:", oldName, "->", name);
        }
        
        setIsAddGateModalOpen(false);
        closeAddGateModal();
        handleToggle();
        setIsUpdateMode(false);
        setadvertIds([]);
        // setSelectedDate();
        setValues([""]);
        setYesNoValue();
        setSelectedCategory();
        setSelectedType();
        setName();
        setOldName("");
      } else {
        message.error("Failed to update gate(s).");
      }
    } catch (error) {
      // message.error("CHECK");
    }
  };

  const UpdateMannualPopulatedGates = async (
    selectedname,
    gateId,
    calendarValue
  ) => {
    try {
      const data = {
        advertId: gateId,
        gateValue: selectedname ? selectedname : null,
        values: calendarValue ? [calendarValue] : null,
      };

      const response = await API_MANAGER.updateMannualPopulatedGates(data);
      // setGateValue(response?.data?.data?.gateValue);
      // console.log(response?.data?.data?.gateValue, "TEST RESP");

      if (response?.status === 201) {
        // message.success("Gates successfully Updates.");
        setIsAddGateModalOpen(false);
      } else {
        message.error("Failed to add gate(s).");
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const handleAddAutoPopulatedGates = async () => {
    const newadvert = advertIds.filter((ids) => !prefilledarray.includes(ids));
    const targetAdverts = newadvert.length > 0 ? newadvert : advertIds;
    try {
      const newlySelectedGates = (selectedGates || []).filter(
        (g) => !defaultGates.includes(g)
      );
      const mappedGateNames = newlySelectedGates.map((g) =>
        g === "next-of-kin" ? "nok" : g
      );

      if (mappedGateNames.length === 0) {
        message.warning("Please select at least one gate to assign.");
        return;
      }

      if (targetAdverts.length === 0) {
        message.warning("Please assign the gate(s) to at least one advert.");
        return;
      }

      const data = {
        advertId: targetAdverts,
        category: "personal details",
        name: mappedGateNames,
      };

      const response = await API_MANAGER.addAutoPopulatedGates(data);

      if (response?.status === 201) {
        message.success("Gate(s) successfully added.");
        
        // Add new gate names to column order ref so they stay at the end
        // This ensures new gates don't disrupt existing order
        if (columnOrderRef.current && mappedGateNames && mappedGateNames.length > 0) {
          const newGateNames = mappedGateNames.filter(name => 
            !columnOrderRef.current.includes(name)
          );
          if (newGateNames.length > 0) {
            const updatedOrder = [...columnOrderRef.current, ...newGateNames];
            columnOrderRef.current = updatedOrder;
            localStorage.setItem("columnOrder", JSON.stringify(updatedOrder));
            console.log("📋 Added new auto gates to column order:", newGateNames);
          }
        }
        
        setadvertIds([]);
        setprefilledarray([]);
        setIsAddGateModalOpen(false);
        setSelectedGates([]);
        handleToggle();
      } else {
        message.error("Failed to add gate(s).");
      }
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setActiveLoader(false);
    }
  };

  // const [selectedType, setSelectedType] = useState(null);

  const handleMenuClick = (e) => {
    setSelectedType(e.key);
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      {options.map((option) => (
        <Menu.Item key={option.label}>{option.label}</Menu.Item>
      ))}
    </Menu>
  );

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  //API
  const handleDeleteSubmit = async (delId) => {
    // let ids;
    // if (delId && Array.isArray(delId)) {
    //   ids = delId;
    // } else if (delId) {
    //   ids = [delId];
    // }

    const param = {
      applicationIds: Array.isArray(selectedRowKeys)
        ? selectedRowKeys
        : [selectedRowKeys],
      value: true,
    };
    try {
      const response = await API_MANAGER.bulkMobilizationDelete(param);

      message.success("Profile successfully removed.");
      handleToggle();
      // handleToggle();
      // setDeleteKeys(null);
      setBulkDeleteModal(false);
      // getCandidateDetails();
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const handleAddMannualPopulatedGates = async () => {
    let filteredValues;
    if (selectedType === "Pick List") {
      filteredValues = values.filter((value) => value !== "");
      setValues(filteredValues);
    }

    const Data = {
      advertId: advertIds,
      category: "personal details",
      type: selectedType.toLowerCase(),
      values:
        selectedType === "Calendar"
          ? [selectedDate]
          : selectedType === "Pick List"
          ? filteredValues
          : selectedType === "Yes/No"
          ? [YesNoValue || "yes"]
          : [],
      name: name,
    };

    if (markAsDefaultOnCreate) {
      try {
        await API_MANAGER.setDefaultManualGates({
          name: Data.name,
          type: Data.type,
          category: Data.category,
          values: Data.values,
        });
        message.success("Gate marked as default.");
        handleToggle();
        setadvertIds([]);
        setValues([""]);
        setYesNoValue();
        setSelectedCategory();
        setSelectedType();
        setName();
        setMarkAsDefaultOnCreate(false);
        setIsAddGateModalOpen(false);
      } catch (defaultErr) {
        const defaultMsg = defaultErr?.response?.data?.message;
        message.error(typeof defaultMsg === "string" ? defaultMsg : (defaultMsg?.message || "Failed to mark as default."));
      }
      return;
    }

    try {
      const response = await API_MANAGER.addMannualPopulatedGates(Data);

      if (response?.status === 201) {
        message.success("Gate(s) successfully added.");
        
        // Add new gate name to column order ref so it stays at the end
        // This ensures the new gate doesn't disrupt existing order
        if (columnOrderRef.current && name) {
          const newGateName = name.toLowerCase();
          if (!columnOrderRef.current.includes(newGateName)) {
            const updatedOrder = [...columnOrderRef.current, newGateName];
            columnOrderRef.current = updatedOrder;
            localStorage.setItem("columnOrder", JSON.stringify(updatedOrder));
            console.log("📋 Added new gate to column order:", newGateName);
          }
        }

        handleToggle();
        setadvertIds([]);
        // setSelectedDate();
        setValues([""]);
        setYesNoValue();
        setSelectedCategory();
        setSelectedType();
        setName();
        setMarkAsDefaultOnCreate(false);
        setIsAddGateModalOpen(false);
      } else {
        message.error("Failed to add gate(s).");
      }
    } catch (error) {
      const errMsg = error?.response?.data?.message;
      message.error(typeof errMsg === 'string' ? errMsg : (errMsg?.message || "An error occurred."));
    }
  };

  const handelSaveGate = () => {
    setActiveLoader(true);
    if (activeTab === "auto") {
      handleAddAutoPopulatedGates();
    } else if (activeTab === "manual") {
      handleAddMannualPopulatedGates();
    }
  };

  const handeldelete = (id) => {
    setBulkDeleteModal(true);
    setSelectedRowKeys(id);
  };
  
  
   
  
  const handelArchive = async (id) => {
    const param = {
      applicationIds: Array.isArray(id) ? id : [id],
      value: true,
    };
    try {
      const response = await API_MANAGER.postArchiveCandidate(param);
      message.success("Profile successfully archived.");
      handleToggle();
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  
  const handelUnarchive = async (id) => {
    const param = {
      applicationIds: Array.isArray(id) ? id : [id],
      value: false,
    };
    try {
      const response = await API_MANAGER.postArchiveCandidate(param);
      message.success("Profile successfully unarchived.");
      if (isArchiveView) {
        await handleOpenArchived();
      } else {
        handleToggle();
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  
  const handleConfirmArchive = async () => {
    setArchiveLoading(true);
    try {
      if (archiveMode === "archive") {
        await handelArchive(archiveTargetIds);
      } else {
        await handelUnarchive(archiveTargetIds);
      }
    } finally {
      setArchiveLoading(false);
      setArchiveModalVisible(false);
      setArchiveTargetIds([]);
    }
  };
  
  const handelassign = () => {
    setTransferModal(true);
    if (selectedGates.length === 1) {
      handelAdvertofGates(selectedGates?.[0]);
    } else if (selectedGates.length > 1) {
      setprefilledarray([]);
    }
  };

  // const handeReset = () => {
  //   setTransferModal(false);
  //   // alert("TRIGGGER");
  //   setadvertIds([]);
  //   setActiveTab("manual");
  //   setIsUpdateMode(false);
  //   setSelectedGates([]);
  //   setActiveAssign(false);
  //   // setSelectedDate();

  //   setValues([""]);
  //   setYesNoValue();
  //   setSelectedCategory();
  //   setSelectedType();
  //   setName();
  //   setOldName("");
  //   setprefilledarray([]);
  // };

  const handleAssignModalOpen = () => {
    setTransferModal(true);
  };

  const getHeaderCellProps = (column) => ({
    onClick: (event) => {
      const sortIcon = event.currentTarget.querySelector(
        ".ant-table-column-sorters"
      );

      if (sortIcon && !sortIcon.contains(event.target)) {
        event.stopPropagation();
      }
    },
  });

  const statusIcons = {
    Yes: <img src={YesIcon} alt="Yes" width="20" height="20" />,
    No: <img src={NoIcon} alt="No" width="20" height="20" />,
    "N/A": <img src={NAIcon} alt="N/A" width="20" height="20" />,
  };

  const generateColumns = (columngatedata) => {
    if (!columngatedata || Object.keys(columngatedata).length === 0) return [];

    let columns = [];

    Object.keys(columngatedata).forEach((key) => {
      const columnTitle = key === "nok" 
        ? "Next-of-Kin" 
        : key.replace(/_/g, " ").toUpperCase();

      // Skip hidden column & excluded columns
      if (
        hidecolumn.includes(key) ||
        [
          "EMAIL",
          "PHOTO",
          // "GENDER",
          // "ADDRESS",
          "ADVERT NAME",
          "CAMPAIGN NAME",
        ].includes(columnTitle)
      )
        return;

      if (key === "details") {
        columns.unshift({
          title: (
            <div style={{ textAlign: "center", marginLeft: "1rem" }}>
              DETAILS
            </div>
          ),
          dataIndex: key,
          key,
          fixed: "left",
          sorter: (a, b) => a?.userName?.localeCompare(b?.userName),
          showSorterTooltip: false,
          width: 290, // Reduced width for compactness
          render: (text, record) => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // marginLeft: "20px",
                alignItems: "center", // changed to center
                gap: "5px", // reduced gap
                padding: "3px", // reduced padding
                borderRadius: "6px", // slightly smaller
                backgroundColor: "#F8FAFC",
                border: "1px solid #E2E8F0",
                // minWidth: "280px",
              }}
            >
              {/* Avatar */}
              <Avatar
                size={50}
                style={{ marginLeft: "4px" }}
                // smaller avatar
                src={
                  record?.photo
                    ? `https://dev-documents-cinchy.s3.ap-southeast-2.amazonaws.com/${record.photo}`
                    : "https://images.freeimages.com/image/thumbs/374/instabutton-png-design-5690390.png"
                }
              />

              {/* User Info with Copy Icons */}
              <div style={{ flex: 1 }}>
                <h3
                  onClick={() =>
                    navigate(`/applicant-profile/${record.userId}`, {
                      state: {
                        id: record.advertIds,
                        fromMobilisation: true,
                        currentPage: currentPage,
                        previousCurrentPage: currentPage,
                        filterState: {
                          selectedItems: selectedAdverts,
                          searchText: searchText,
                          sortValue: sortValue,
                          badgeIds: badgeIds,
                          isFilterUsing: isFilterUsing,
                        },
                      },
                    })
                  }
                  style={{
                    fontWeight: 600,
                    color: "#1E40AF",
                    fontSize: "14px", // slightly smaller
                    margin: "0 0 4px 0",
                    cursor: "pointer",
                  }}
                >
                  {record?.userName || "NA"}
                </h3>

                <span
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {record.email}
                  <CopyOutlined
                    style={{
                      marginLeft: 4,
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#1890ff",
                    }}
                    onClick={() => handleCopy(record.email)}
                  />
                </span>

                <span
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {"0" + record.phoneNumber}
                  <CopyOutlined
                    style={{
                      marginLeft: 4,
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#1890ff",
                    }}
                    onClick={() => handleCopy("0" + record.phoneNumber)}
                  />
                </span>

                <span
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ fontWeight: 500 }}>Availability:</span>{" "}
                  {record.availability || "NA"}
                </span>
              </div>

              {/* Action Buttons */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "25%",
                  gap: "6px",
                  alignItems: "center",
                  position: "relative",
                  zIndex: 1000,
                }}
              >
                <Tooltip 
                  title="Hide profile" 
                  placement="top"
                  overlayStyle={{ zIndex: 9999 }}
                  overlayInnerStyle={{ fontSize: '12px' }}
                >
                  <span>
                    <EyeOutlined
                      onClick={() => handelEyeClick(record?.jobId)}
                      style={{
                        color: "#3B82F6",
                        fontSize: "14px",
                        marginTop:"6px",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                </Tooltip>
                
                <Tooltip 
                  title="Remove profile" 
                  placement="top"
                  overlayStyle={{ zIndex: 9999 }}
                  overlayInnerStyle={{ fontSize: '12px' }}
                >
                  <span>
                    <DeleteOutlined
                      onClick={() => handeldelete(record.jobId)}
                      style={{
                        color: "red",
                        fontSize: "14px",
                                                marginTop:"5px",

                        cursor: "pointer",
                      }}
                    />
                  </span>
                </Tooltip>
                
                <Tooltip 
                  title={isArchiveView ? "Unarchive profile" : "Archive profile"} 
                  placement="top"
                  overlayStyle={{ zIndex: 9999 }}
                  overlayInnerStyle={{ fontSize: '12px' }}
                >
                  <span>
                    <img
                      src={isArchiveView ? UnarchiveIcon : ArchiveIcon}
                      onClick={() => {
                        setArchiveMode(isArchiveView ? "unarchive" : "archive");
                        setArchiveTargetIds([record.jobId]);
                        setArchiveModalVisible(true);
                      }}
                      alt={isArchiveView ? "Unarchive Icon" : "Archive Icon"}
                      width="14"
                      height="14"
                      style={{ cursor: "pointer" }}
                    />
                  </span>
                </Tooltip>

                <Tooltip 
                  title="Return to advert" 
                  placement="top"
                  overlayStyle={{ zIndex: 9999 }}
                  overlayInnerStyle={{ fontSize: '12px' }}
                >
                  <span>
                    <img
                      src={MyIcon}
                      alt="Custom Icon"
                      width="14"
                      height="14"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/advert-detail/${record.advertIds}`, {
                          state: {
                            userName: record?.userName,
                            fromMobilisation: true,
                            currentPage: currentPage,
                            previousCurrentPage: currentPage,
                            mobilisationFilterState: {
                              selectedItems: selectedAdverts,
                              searchText: searchText,
                              sortValue: sortValue,
                              badgeIds: badgeIds,
                              isFilterUsing: isFilterUsing,
                              currentPage: currentPage,
                            },
                          },
                        })
                      }
                    />
                  </span>
                </Tooltip>
               
              </div>
            </div>
          ),
          onHeaderCell: getHeaderCellProps,
        });
      } else {
        columns.push({
          title: <div style={{ textAlign: "center" }}>{columnTitle}</div>,
          dataIndex: key,
          key,
          align: "center",
          sorter: (a, b) => {
            const formatValue = (val) => {
              if (typeof val === "string") return val.toLowerCase();
              if (typeof val === "number") return val.toString();
              if (val instanceof Date) return val.toISOString();
              if (val && typeof val === "object") {
                try {
                  const str = JSON.stringify(val, null, 2);

                  return str;
                } catch (e) {
                  return "1";
                }
              }

              return "1";
            };

            const valA = formatValue(a[key]);
            const valB = formatValue(b[key]);

            return valA.localeCompare(valB);
          },
          showSorterTooltip: false,
          width: 200,
          // fixed: key === "campaign-adverts" ? "right" : undefined,
          render: (value, record) => {
            const icon = statusIcons[value];

            if (key === "gender") {
              if (typeof value !== "string") {
                return <span>{value}</span>;
              }

              return (
                <span>{value.charAt(0).toUpperCase() + value.slice(1)}</span>
              );
            }

            if (key === "hard requirments") {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {icon ? (
                    <Tooltip title="Click to redirect to hard requirement">
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          localStorage.setItem("editType", "HARD_REQUIREMENTS");
                          navigate(`/advert-tracker/${record.advertIds}`, {
                            state: {
                              userName: record?.userName,
                              search: record?.userName,
                              fromMobilisation: true,
                              currentPage: currentPage,
                              tabType: "HARD_REQUIREMENTS",
                              mobilisationFilterState: {
                                selectedItems: selectedAdverts,
                                searchText: searchText,
                                sortValue: sortValue,
                                badgeIds: badgeIds,
                                isFilterUsing: isFilterUsing,
                                currentPage: currentPage,
                              },
                            },
                          });
                        }}
                      >
                        {icon}
                      </div>
                    </Tooltip>
                  ) : (
                    <span>{value}</span>
                  )}
                </div>
              );
            }
            if (key === "soft requirments") {
              return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {icon ? (
                    <Tooltip title="Click to redirect to soft requirement">
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          localStorage.setItem("editType", "SOFT_REQUIREMENTS");
                          navigate(`/advert-tracker/${record.advertIds}`, {
                            state: {
                              userName: record?.userName,
                              search: record?.userName,
                              fromMobilisation: true,
                              currentPage: currentPage,
                              tabType: "SOFT_REQUIREMENTS",
                              mobilisationFilterState: {
                                selectedItems: selectedAdverts,
                                searchText: searchText,
                                sortValue: sortValue,
                                badgeIds: badgeIds,
                                isFilterUsing: isFilterUsing,
                                currentPage: currentPage,
                              },
                            },
                          });
                        }}
                      >
                        {icon}
                      </div>
                    </Tooltip>
                  ) : (
                    <span>{value}</span>
                  )}
                </div>
              );
            }

            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {icon ? <span>{icon}</span> : <span>{value}</span>}
              </div>
            );
          },

          onHeaderCell: getHeaderCellProps,
        });
      }
    });

    return columns;
  };

  const [columns, setColumns] = useState([]);
  
  // Ref to track the current column order as the source of truth
  // This ensures order is preserved during edits and only changes via drag
  const columnOrderRef = useRef(null);

  useEffect(() => {
    if (columngatedata) {
      console.log(columngatedata, "TESTDATEGATE1213");
      const generatedCols = generateColumns(columngatedata);

      // Priority for column order:
      // 1. Current column order from ref (preserves order during edits)
      // 2. Saved order from localStorage
      // 3. Default generated order
      let savedOrder = columnOrderRef.current;
      
      // Always try localStorage as backup if ref is empty
      if (!savedOrder || savedOrder.length === 0) {
        const localStorageOrder = JSON.parse(localStorage.getItem("columnOrder"));
        if (localStorageOrder && Array.isArray(localStorageOrder) && localStorageOrder.length > 0) {
          savedOrder = localStorageOrder;
          // Initialize ref from localStorage on first load
          columnOrderRef.current = localStorageOrder;
        }
      }

      console.log("📋 Applying column order from:", savedOrder ? "saved order" : "default", savedOrder);

      if (savedOrder && Array.isArray(savedOrder) && savedOrder.length > 0) {
        const reordered = savedOrder
          .map((key) => generatedCols.find((col) => col.key === key))
          .filter(Boolean); // Remove any unmatched keys

        // Also include any new columns not in savedOrder (append at end)
        const remainingCols = generatedCols.filter(
          (col) => !savedOrder.includes(col.key)
        );

        const finalColumns = [...reordered, ...remainingCols];
        setColumns(finalColumns);
        
        // Only update ref if this is the first time (ref was empty before)
        // This prevents overwriting the user's drag order during edits
        // The ref should only be updated via drag, rename, or initial load
        if (!columnOrderRef.current || columnOrderRef.current.length === 0) {
          columnOrderRef.current = finalColumns.map(col => col.key);
          console.log("📋 Initialized column order ref:", columnOrderRef.current);
        }
      } else {
        setColumns(generatedCols);
        // Initialize ref with generated order only if not already set
        if (!columnOrderRef.current || columnOrderRef.current.length === 0) {
          columnOrderRef.current = generatedCols.map(col => col.key);
          console.log("📋 Initialized column order ref with default:", columnOrderRef.current);
        }
      }
    }
  }, [columngatedata, hidecolumn]);

  const shouldScroll = columns.length > 6;

  const SortableColumn = ({ title, columnKey }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id: columnKey });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      display: "flex",
      alignItems: "center",
      gap: 8,
      cursor: "grab",
    };

    console.log("🔧 SortableColumn rendered for:", columnKey);

    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        onMouseDown={() => console.log("🖱️ Mouse down on column:", columnKey)}
      >
        <MenuOutlined />
        <span>{title}</span>
      </div>
    );
  };

  // const [columns, setColumns] = useState(initialColumns);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 }, // Prevents accidental drags
    })
  );

  const onDragEnd = async (event) => {
    console.log("🚀 onDragEnd triggered!", event);
    const { active, over } = event;

    if (!over || active.id === over.id) {
      console.log("❌ No valid drag operation");
      return;
    }

    console.log("✅ Valid drag operation detected");
    console.log("Active ID:", active.id);
    console.log("Over ID:", over.id);

    const oldIndex = columns.findIndex((col) => col.key === active.id);
    const newIndex = columns.findIndex((col) => col.key === over.id);

    console.log("Old Index:", oldIndex);
    console.log("New Index:", newIndex);

    const newCols = arrayMove(columns, oldIndex, newIndex);
    setColumns(newCols);

    // Save reordered column keys to localStorage and ref
    const columnOrder = newCols.map((col) => col.key);
    localStorage.setItem("columnOrder", JSON.stringify(columnOrder));
    
    // Update the ref to ensure order persists through edits
    columnOrderRef.current = columnOrder;

    console.log("📋 New column order:", columnOrder);

    // Check if filters are applied - only call API if no filters are active
    if (isFilterUsing) {
      console.log("🚫 Filters are applied - skipping draggable API call");
      return;
    }

    // Call API to save column order only when no filters are applied
    try {
      console.log("📡 Calling API with data:", {
        columnOrder: columnOrder,
        feature: "MOBILISATION",
      });

      const response = await API_MANAGER.draggablePosition({
        order: columnOrder,
        feature: "MOBILISATION",
      });

      console.log("✅ API call successful:", response);
      // message.success("Column order successfully saved!");
    } catch (error) {
      // console.error("❌ Failed to save column order:", error);
      // message.error("Failed to save column order. Please try again.");
    }
  };

  // State to track if we've already fetched column order
  const [hasFetchedColumnOrder, setHasFetchedColumnOrder] = useState(false);

  useEffect(() => {
    const fetchColumnOrder = async () => {
      try {
        console.log("🔄 Fetching column order from API...");
        const response = await API_MANAGER.getdraggablePosition();
        console.log("📡 API Response:", response);

        if (response?.data?.data?.order) {
          const savedOrder = response.data.data.order;
          console.log("📋 Retrieved column order:", savedOrder);

          if (Array.isArray(savedOrder) && savedOrder.length > 0) {
            const reordered = savedOrder
              .map((key) => columns.find((col) => col.key === key))
              .filter(Boolean); // Remove any unmatched keys

            // Also include any new columns not in savedOrder (append at end)
            const remainingCols = columns.filter(
              (col) => !savedOrder.includes(col.key)
            );

            const finalColumns = [...reordered, ...remainingCols];
            setColumns(finalColumns);
            
            // Update ref and localStorage with API order for consistency
            const orderKeys = finalColumns.map(col => col.key);
            columnOrderRef.current = orderKeys;
            localStorage.setItem("columnOrder", JSON.stringify(orderKeys));
            console.log("✅ Column order applied from API and synced to localStorage");
          } else {
            console.log(
              "⚠️ No valid column order found in API response, using localStorage fallback"
            );
            applyLocalStorageOrder();
          }
        } else {
          console.log(
            "⚠️ No order data in API response, using localStorage fallback"
          );
          applyLocalStorageOrder();
        }
      } catch (error) {
        console.error("❌ Error fetching column order from API:", error);
        console.log("🔄 Falling back to localStorage");
        applyLocalStorageOrder();
      }
    };

    const applyLocalStorageOrder = () => {
      const savedOrder = JSON.parse(localStorage.getItem("columnOrder"));
      if (savedOrder && Array.isArray(savedOrder) && savedOrder.length > 0) {
        const reordered = savedOrder
          .map((key) => columns.find((col) => col.key === key))
          .filter(Boolean); // Remove any unmatched keys

        // Also include any new columns not in savedOrder (append at end)
        const remainingCols = columns.filter(
          (col) => !savedOrder.includes(col.key)
        );

        const finalColumns = [...reordered, ...remainingCols];
        setColumns(finalColumns);
        
        // Update ref with localStorage order to preserve it during edits
        columnOrderRef.current = finalColumns.map(col => col.key);
        console.log("✅ Column order applied from localStorage");
      }
    };

    // Only fetch column order once when columns are initially generated
    if (columns.length > 0 && !hasFetchedColumnOrder) {
      setHasFetchedColumnOrder(true);
      fetchColumnOrder();
    }
  }, [columns, hasFetchedColumnOrder]);

  const finishGatesExport = () => {
    if (exportTimeoutRef.current) {
      clearTimeout(exportTimeoutRef.current);
      exportTimeoutRef.current = null;
    }
    exportingGatesRef.current = false;
    setExportingGates(false);
  };

  useEffect(() => {
    ensureSocketConnected();
    waitForSocketConnected().catch(() => {});

    const handleDownloaded = () => {
      finishGatesExport();
    };

    const handleFailed = () => {
      finishGatesExport();
    };

    window.addEventListener("cinchy-gates-export-downloaded", handleDownloaded);
    window.addEventListener("cinchy-gates-export-failed", handleFailed);
    return () => {
      window.removeEventListener("cinchy-gates-export-downloaded", handleDownloaded);
      window.removeEventListener("cinchy-gates-export-failed", handleFailed);
      if (exportTimeoutRef.current) {
        clearTimeout(exportTimeoutRef.current);
        exportTimeoutRef.current = null;
      }
    };
  }, []);

  const handleExportGatesCsv = async () => {
    if (exportingGatesRef.current) return;

    const adverts =
      selectedAdverts.length > 0 ? selectedAdverts : advertIdsfinal;
    if (!adverts.length) {
      message.warning("No gates data to export yet");
      return;
    }

    if (typeof window !== "undefined") {
      window.__cinchyLastSocketExport = null;
    }
    exportingGatesRef.current = true;
    setExportingGates(true);

    if (exportTimeoutRef.current) clearTimeout(exportTimeoutRef.current);
    exportTimeoutRef.current = setTimeout(() => {
      if (!exportingGatesRef.current) return;
      exportingGatesRef.current = false;
      setExportingGates(false);
      message.error("Gates CSV export timed out. Please try again.");
    }, 180000);

    try {
      await waitForSocketConnected();
      const response = await API_MANAGER.exportMobilisationGates({
        adverts,
        searchText,
        sortValue: sortValue || "recentlyAdded",
        archive: isArchiveView,
      });

      const inlineFile = readExportPayload(response?.data?.data || response?.data);
      if (inlineFile?.type === "mobilisation" && inlineFile?.base64) {
        downloadMobilisationExport(inlineFile);
        if (exportingGatesRef.current) finishGatesExport();
        return;
      }

      if (response?.data?.isSuccess === false) {
        finishGatesExport();
        message.error(response?.data?.message || "Failed to export gates CSV");
        return;
      }

      message.success("Preparing gates CSV. The file will download when it is ready.");
    } catch (error) {
      finishGatesExport();
      message.error(
        error?.response?.data?.message || "Failed to export gates CSV"
      );
    }
  };

  const handleOpenArchived = async () => {
    setLoadingTable(true);
    setActiveLoader(true);
    try {
      const dataParams = {
        adverts: advertIdsfinal,
        searchText: searchText,
        sortValue: sortValue,
        currentPage: currentPage,
      };
      const response = await API_MANAGER.postGateDataArchive(dataParams);
      if (response?.data?.isSuccess) {
        setmobilzationColumn(response?.data?.data?.column);
        setfilterDataUser(response?.data?.data?.users);
        settotalRecord(response?.data?.data?.totalRecords);
        setIsArchiveView(true);
      }
    } catch (error) {
      message.error("Failed to load archived candidates.");
    } finally {
      setLoadingTable(false);
      setActiveLoader(false);
    }
  };

  const handleBackToInitial = async () => {
    setLoadingTable(true);
    setActiveLoader(true);
    try {
      const dataParams = {
        adverts: advertIdsfinal,
        searchText: searchText,
        sortValue: sortValue,
        currentPage: currentPage,
      };
      const response = await API_MANAGER.postGateData(dataParams);
      if (response?.data?.isSuccess) {
        setmobilzationColumn(response?.data?.data?.column);
        setfilterDataUser(response?.data?.data?.users);
        settotalRecord(response?.data?.data?.totalRecords);
        setIsArchiveView(false);
      }
    } catch (error) {
      message.error("Failed to load candidates.");
    } finally {
      setLoadingTable(false);
      setActiveLoader(false);
    }
  };
  console.log(location,"LOCATION DATA")

  const autoDefaultGatesHasChanges = (() => {
    const normalizedDefaultKeys = [
      ...new Set(defaultGates.map((k) => getGateKeyFromLabel(k))),
    ];
    const finalSelected = [
      ...new Set(tempSelectedAutoDefaults.map((k) => getGateKeyFromLabel(k))),
    ];
    if (normalizedDefaultKeys.length !== finalSelected.length) return true;
    const sortedDefaults = [...normalizedDefaultKeys].sort();
    const sortedSelected = [...finalSelected].sort();
    return sortedDefaults.some((key, index) => key !== sortedSelected[index]);
  })();

  return (
    <SubLayout currentPage={currentPage} page={"Mobilisation Management"}  whiteBg showSearch>
      {/* {!search && <FullScreenLoader isLoading={loading} />} */}
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          height: "calc(90vh - 100px)",
          // overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
            padding: "10px",
          }}
        >
          {/* <div style={{ flex: "1 1 auto", minWidth: "250px" }}>
            <h2 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              Mobilisation Management
            </h2>
            <p style={{ color: "gray", margin: 0 }}>
              Customise the requirements for shortlisted candidates
            </p>
          </div> */}
          <DeleteModal
            visible={bulkDeleteModal}
            setVisible={setBulkDeleteModal}
            text={"Profile"}
            handleSubmit={handleDeleteSubmit}
            // loading={deleteLoading}
          />

          <ArchiveConfirmModal
            visible={archiveModalVisible}
            setVisible={setArchiveModalVisible}
            mode={archiveMode}
            text={"Profile"}
            onConfirm={handleConfirmArchive}
            loading={archiveLoading}
          />

          <TransferModal
            transferModal={transferModal}
          
            setTransferModal={setTransferModal}
            activeTab={activeTab}
            candidateSelectedData={candidateSelectedData}
            oldAdvertId={oldAdvertId}
            profileId={profileId}
            candidateName={candidateName}
            setReloadState={setReloadState}
            setfilterDataAdvert={setfilterDataAdvert}
            handleAddAutoPopulatedGates={handleAddAutoPopulatedGates}
            transferData={transferData}
            search={advertSearch}
            setSearch={setAdvertSearch}
            setadvertIds={setadvertIds}
            prefilledarray={prefilledarray}
            oldName={oldName}
            setSelectedGates={setSelectedGates}
            assignGates={assignGates}
            activeAssing={activeAssing}
            isUpdateMode={isUpdateMode}
            setIsUpdateMode={setIsUpdateMode}
            // setbadgeIds={setbadgeIds}
            setIsAddGateModalOpen={setIsAddGateModalOpen}
            advertIds={advertIds}
            handleAddMannualPopulatedGates={handleAddMannualPopulatedGates}
          />
          {/* Responsive adjustments */}
          <style>
            {`
          .mobilisation-sort-popover .ant-popover-inner {
            background-color: #fff !important;
            color: #000 !important;
            min-width: auto !important;
            width: auto !important;
            padding: 0 !important;
          }
          .mobilisation-sort-popover .ant-popover-inner-content {
            color: #000 !important;
          }
          .mobilisation-sort-popover .ant-popover-arrow,
          .mobilisation-sort-popover .ant-popover-arrow::before,
          .mobilisation-sort-popover .ant-popover-arrow::after {
            display: none !important;
            background-color: #fff !important;
          }
          @media (max-width: 768px) {
            .mobilisation-toolbar {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            .mobilisation-search-container {
              width: 100%;
            }
            .mobilisation-search-input {
              width: 100% !important;
            }
            .mobilisation-actions-container {
              flex-direction: column !important;
              width: 100%;
            }
            .mobilisation-row-1 {
              width: 100%;
              justify-content: flex-start !important;
              flex-wrap: wrap;
            }
            .mobilisation-row-2 {
              width: 100%;
              justify-content: flex-start !important;
              flex-wrap: wrap;
            }
            /* Mobile table responsiveness - remove fixed column */
            .custom-table .ant-table-cell-fix-left,
            .custom-table .ant-table-cell-fix-left-last {
              position: relative !important;
              left: auto !important;
              z-index: auto !important;
              background: inherit !important;
            }
            .custom-table .ant-table-content {
              overflow-x: auto !important;
              -webkit-overflow-scrolling: touch;
            }
            .custom-table .ant-table {
              min-width: 100%;
            }
            .custom-table .ant-table-thead > tr > th,
            .custom-table .ant-table-tbody > tr > td {
              white-space: nowrap;
            }
            /* Add Gate Modal Mobile Responsiveness */
            .add-gate-modal .ant-modal {
              max-width: 95vw !important;
              margin: 10px !important;
              padding: 0 !important;
            }
            .add-gate-modal .ant-modal-content {
              padding: 16px !important;
            }
            .add-gate-modal .ant-modal-body {
              height: auto !important;
              max-height: 60vh !important;
              overflow-y: auto !important;
              padding: 12px 0 !important;
            }
            .add-gate-modal .ant-modal-footer {
              padding: 12px 0 0 0 !important;
            }
            .add-gate-modal .ant-modal-footer .ant-row {
              flex-direction: row !important;
              gap: 8px !important;
            }
            .add-gate-modal .ant-modal-footer .ant-col {
              flex: 1 !important;
              max-width: 50% !important;
            }
            .add-gate-modal .modal-tabs-container {
              flex-direction: column !important;
              gap: 10px !important;
            }
            .add-gate-modal .modal-content-row {
              flex-direction: column !important;
            }
            .add-gate-modal .modal-content-row > div {
              width: 100% !important;
              max-width: 100% !important;
            }
            .add-gate-modal .type-buttons-container {
              flex-wrap: wrap !important;
            }
            .add-gate-modal .type-buttons-container button {
              min-width: 100px !important;
              padding: 15px 12px !important;
              font-size: 12px !important;
            }
            .add-gate-modal .preview-section {
              margin-top: 16px !important;
              justify-content: center !important;
            }
            .add-gate-modal .preview-box {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 200px !important;
            }
            /* Show/Hide Popover Mobile Responsiveness */
            .show-hide-popover {
              max-width: 95vw !important;
              left: 2.5vw !important;
              right: 2.5vw !important;
            }
            .show-hide-popover .ant-popover-inner {
              padding: 0 !important;
            }
            .show-hide-popover .show-hide-content {
              width: 100% !important;
              max-width: 100% !important;
              flex-direction: column !important;
              padding: 10px !important;
              position: relative !important;
            }
            .show-hide-popover .show-hide-search-header {
              position: relative !important;
              top: auto !important;
              left: auto !important;
              right: auto !important;
              width: 100% !important;
              margin-bottom: 10px !important;
            }
            .show-hide-popover .show-hide-column {
              width: 100% !important;
              padding-top: 10px !important;
            }
            .show-hide-popover .show-hide-column h4 {
              margin-top: 5px !important;
              font-size: 13px !important;
            }
            .show-hide-popover .show-hide-column > div {
              max-height: 180px !important;
            }
          }
        `}
          </style>
        </div>

        <div
          className="mobilisation-toolbar"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 10,
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {/* Left Section */}
          <div className="mobilisation-search-container" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <Input
              prefix={<SearchOutlined style={{ color: "#1638B1" }} />}
              placeholder="Search by candidate, campaign or advert name."
              value={searchText}
              allowClear
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              className="mobilisation-search-input"
              style={{
                height: 40,
                borderRadius: 6,
                backgroundColor: "#FFFFFF",
                border: "1px solid #E2E8F0",
                boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                color: "#64748B",
                fontSize: "14px",
                fontWeight: "400",
                padding: "0px 12px",
                width: "375px",
                minWidth: "150px",
              }}
            />
          </div>
          <div className="mobilisation-actions-container" style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <div className="mobilisation-row-1" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <div style={{ marginTop: "-15px" }}>
                <Badge
                  size="default"
                  count={badgeIds.length}
                  style={{
                    marginLeft: "6rem",
                    marginBottom: "-0.4rem",
                    zIndex: "999",
                  }}
                ></Badge>
                <div>
                  <TransferPopover
                    transferModal={visibleFilter}
                    setTransferModal={setVisibleFilter}
                    setonFilterPagination={setonFilterPagination}
                    onfilterPagination={onfilterPagination}
                    candidateSelectedData={candidateSelectedData}
                    oldAdvertId={oldAdvertId}
                    setCurrentPage={setCurrentPage}
                    isFilterUsing={isFilterUsing}
                    setIsFilterUsing={setIsFilterUsingState}
                    profileId={profileId}
                    selectedAdverts={selectedAdverts}
                    setSelectedAdverts={setSelectedAdverts}
                    candidateName={candidateName}
                    setReloadState={setReloadState}
                    setfilterDataAdvert={setfilterDataAdvert}
                    settotalRecord={settotalRecord}
                    transferData={transferData}
                    search={advertSearch}
                    setSearch={setAdvertSearch}
                    setadvertIds={setadvertIds}
                    advertIds={advertIds}
                    setfilterDataUser={setfilterDataUser}
                    reloadState={reloadState}
                    setmobilzationColumn={setmobilzationColumn}
                    searchText={searchText}
                    sortValue={sortValue}
                    setLoadingTable={setLoadingTable}
                    setActiveLoader={setActiveLoader}
                    refreshToggle={refreshToggle}
                    currentPage={currentPage}
                    setbadgeIds={setbadgeIds}
                    data={data}
                    columns={columns}
                    setDeselectTrigger={setDeselectTrigger}
                    isArchiveView={isArchiveView}
                  />
                </div>
              </div>
              <ShowHideColumnsPopover
                setSelectedGates={setSelectedGates}
                setCurrentPage={setCurrentPage}
                handleToggle={handleToggle}
                setPrevGateName={setPrevGateName}
                setSelectedRowKeys={setSelectedRowKeys}
                handleDeleteSubmit={handleDeleteSubmit}
                setmobilzationColumn={mobilzationColumn}
                columnsvisible={columnsvisible}
                toggleVisibility={toggleVisibility}
                sethidecolumn={sethidecolumn}
                hidecolumn={hidecolumn}
                setRefreshToggle={handleToggle}
                sethideRow={sethideRow}
                hideRow={hideRow}
                handeldeleteRow={handeldelete}
                rowData={data}
                advertId={advertIds}
                advertIdsfinal={advertIdsfinal}
                candidateSelectedData={candidateSelectedData}
                oldAdvertId={oldAdvertId}
                profileId={profileId}
                candidateName={candidateName}
                setReloadState={setReloadState}
                setfilterDataAdvert={setfilterDataAdvert}
                transferData={transferData}
                search={advertSearch}
                setSearch={setAdvertSearch}
                setadvertIds={setadvertIds}
                advertIds={advertIds}
                handleAddMannualPopulatedGates={handleAddMannualPopulatedGates}
                isArchiveView={isArchiveView}
              />

              <Popover
                content={contentSort}
                trigger="click"
                placement="bottomLeft"
                arrow={false}
                overlayClassName="mobilisation-sort-popover"
                open={visibleSort}
                onOpenChange={setvisibleSort}
                overlayStyle={{
                  borderRadius: 8,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                }}
                overlayInnerStyle={{ backgroundColor: "#fff", padding: "0px" }}
              >
                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    background: "#F8FAFC",
                    border: "1px solid #E2E8F0",
                    borderRadius: "8px",
                    padding: "20px 12px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#64748B",
                    cursor: "pointer",
                    boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "28px",
                      height: "28px",
                      background: "#EEF4FF",
                      borderRadius: "6px",
                    }}
                  >
                    <EditOutlined
                      style={{ fontSize: "16px", color: "#1638B1" }}
                    />
                  </div>
                  Sort
                </Button>
              </Popover>
            </div>

            <div className="mobilisation-row-2" style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Button
                loading={exportingGates}
                disabled={exportingGates}
                onClick={handleExportGatesCsv}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  height: "40px",
                  background: "#F8FAFC",
                  border: "1px solid #E2E8F0",
                  borderRadius: "8px",
                  padding: "10px 12px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#64748B",
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                }}
              >
                <DownloadOutlined style={{ fontSize: "16px", color: "#1638B1" }} />
                {exportingGates ? "Exporting..." : "Export CSV"}
              </Button>
              <ArchiveCandidates onClick={isArchiveView ? handleBackToInitial : handleOpenArchived} isArchiveView={isArchiveView} />

              <Button
                style={{
                  display: "flex",
                  width: "162px",
                  height: "40px",
                  padding: "10px 20px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "5px",
                  borderRadius: "8px",
                  background: "#f9cf66",
                  color: "#091647",
                  textAlign: "center",
                  fontFamily: "Arial",
                  fontSize: "16px",
                  fontWeight: "700",
                  border: "none",
                  boxShadow: "none",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.target.style.color = "#091647")}
                onMouseOut={(e) => (e.target.style.color = "#091647")}
                onClick={openAddGateModal}
              >
                + Add Gate
              </Button>
            </div>

            <Modal
              title={isUpdateMode ? "Edit Gate" : "Add Gate"}
              width={830}
              open={isAddGateModalOpen}
              onCancel={closeAddGateModal}
              bodyStyle={{ height: 428 }}
              centered
              getContainer={document.body}
              maskClosable={false}
              wrapClassName="add-gate-modal"
              footer={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center", gap: "16px" }}>
                    {ENABLE_DEFAULT_GATES && activeTab === "auto" && (
                      <>
                        <span
                            onClick={() => {
                              if (savingDefaultGates) return;
                              if (isEditingDefaultGates) {
                                if (!autoDefaultGatesHasChanges) return;
                                setDefaultGateConfirmType("edit");
                              } else {
                                setTempSelectedAutoDefaults([...defaultGates]);
                                setIsEditingDefaultGates(true);
                              }
                            }}
                            style={{
                              color: "#122D8E",
                              fontFamily: "Arial",
                              fontSize: "14px",
                              fontWeight: 700,
                              textDecoration: "underline",
                              cursor:
                                savingDefaultGates ||
                                (isEditingDefaultGates && !autoDefaultGatesHasChanges)
                                  ? "not-allowed"
                                  : "pointer",
                              opacity:
                                savingDefaultGates ||
                                (isEditingDefaultGates && !autoDefaultGatesHasChanges)
                                  ? 0.6
                                  : 1,
                            }}
                          >
                            {isEditingDefaultGates ? "Save" : "Default Gates"}
                          </span>
                        {isEditingDefaultGates && !savingDefaultGates && (
                          <span
                            onClick={() => {
                              setTempSelectedAutoDefaults([]);
                              setIsEditingDefaultGates(false);
                            }}
                            style={{
                              color: "#122D8E",
                              fontFamily: "Arial",
                              fontSize: "14px",
                              fontWeight: 700,
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            Cancel
                          </span>
                        )}
                      </>
                    )}
                    {ENABLE_DEFAULT_GATES && activeTab === "manual" && (
                      <span
                        onClick={async () => {
                          if (savingDefaultTemplateList) return;
                          setManualDefaultModalOpen(true);
                          const result = await fetchDefaultTemplateList();
                          setManualDefaultTempSelected(result?.defaults ?? []);
                        }}
                        style={{
                          color: "#122D8E",
                          fontFamily: "Arial",
                          fontSize: "14px",
                          fontWeight: 700,
                          textDecoration: "underline",
                          cursor: savingDefaultTemplateList ? "not-allowed" : "pointer",
                          opacity: savingDefaultTemplateList ? 0.4 : 1,
                        }}
                      >
                        Default Gates
                      </span>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  <div>
                    <Button
                      onClick={closeAddGateModal}
                      style={{
                        width: "160px",
                        height: "40px",
                        borderRadius: "8px",
                        border: "1px solid #122D8E",
                        background: "#FFF",
                        boxShadow: "0px 1px 8px -4px rgba(0, 0, 0, 0.12)",
                        color: "#071135",
                        textAlign: "center",
                        fontFamily: "Arial ",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div>
                    {(() => {
                      const newlySelected = (selectedGates || []).filter(
                        (g) => !defaultGates.includes(g)
                      );
                      const autoDisabled =
                        newlySelected.length === 0 || advertIds.length === 0;
                      const manualFieldsEntered = !!name && !!selectedType;
                      const manualGateHasChanges = (() => {
                        const orig = originalManualGateRef.current;
                        if (!orig) return true;
                        if ((name || "") !== (orig.name || "")) return true;
                        if (selectedType !== orig.type) return true;
                        const newlyAssigned = (advertIds || []).filter(
                          (id) => !(prefilledarray || []).includes(id)
                        );
                        if (newlyAssigned.length > 0) return true;
                        if (selectedType === "Pick List") {
                          const cur = (values || []).filter((v) => v !== "");
                          return (
                            JSON.stringify(cur) !==
                            JSON.stringify(orig.values || [])
                          );
                        }
                        if (selectedType === "Yes/No") {
                          return (
                            JSON.stringify(YesNoValue || []) !==
                            JSON.stringify(orig.values || [])
                          );
                        }
                        if (selectedType === "Calendar") {
                          return (
                            dayjs(selectedDate).format("YYYY-MM-DD") !==
                            dayjs(orig.values).format("YYYY-MM-DD")
                          );
                        }
                        return false;
                      })();
                      const manualDisabled = isUpdateMode
                        ? !manualFieldsEntered || !manualGateHasChanges
                        : markAsDefaultOnCreate
                        ? !manualFieldsEntered
                        : !manualFieldsEntered || advertIds.length === 0;
                      const isDisabled =
                        activeTab === "auto" ? autoDisabled : manualDisabled;
                      return (
                    <Tooltip
                      title={
                        isDisabled
                          ? "Please assign the gate(s), to activate the Save button."
                          : ""
                      }
                      placement="top"
                      overlayInnerStyle={{ textAlign: "center" }}
                    >
                      <span style={{ display: "block", width: "100%" }}>
                        <Button
                          type="primary"
                          onClick={
                            noUnderlineKeys.includes(oldName)
                              ? handelSaveGate
                              : isUpdateMode
                              ? updateFullMannualGate
                              : handelSaveGate
                          }
                          disabled={isDisabled}
                          style={{
                            width: "160px",
                            height: "40px",
                            borderRadius: "8px",
                            backgroundColor: "#F9CF66",
                            border: "none",
                            color: "#091647",
                            textAlign: "center",
                            fontFamily: "Arial",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "normal",
                            opacity: isDisabled ? 0.5 : 1,
                          }}
                        >
                          {isUpdateMode ? "Update" : "Save"}
                        </Button>
                      </span>
                    </Tooltip>
                      );
                    })()}
                  </div>
                  </div>
                </div>
              }
            >
              {/* Tabs */}
              <div
                className="modal-tabs-container"
                style={{
                  display: "flex",
                  gap: "12px",
                  fontWeight: "bold",
                  flexWrap: "wrap",
                  marginBottom: "24px",
                  marginTop: "24px",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span
                    style={{
                      color: activeTab === "auto" ? "#000" : "#A0A0A0",
                      cursor: "pointer",
                      borderBottom:
                        activeTab === "auto" ? "2px solid #000" : "none",
                      paddingBottom: "4px",
                    }}
                    onClick={() => setActiveTab("auto")}
                  >
                    {isManual
                      ? " "
                      : noUnderlineKeys.includes(oldName)
                      ? "AUTO POPULATED "
                      : " AUTO POPULATED"}
                  </span>
                  <span
                    style={{
                      marginLeft: "10px",
                      color: activeTab === "manual" ? "#000" : "#A0A0A0",
                      cursor: "pointer",
                      borderBottom:
                        activeTab === "manual" ? "2px solid #000" : "none",
                      paddingBottom: "4px",
                    }}
                    onClick={() => setActiveTab("manual")}
                  >
                    {noUnderlineKeys.includes(oldName)
                      ? " "
                      : isUpdateMode
                      ? "MANUAL CREATION"
                      : "MANUAL CREATION"}
                  </span>
                </div>
                <div>
                  <Col>
                    {(() => {
                      const isEditManualFlow = isUpdateMode && activeTab === "manual";
                      const assignDisabled = isEditManualFlow
                        ? false
                        : activeTab === "manual"
                        ? markAsDefaultOnCreate
                        : isEditingDefaultGates || markAsDefaultOnCreate;
                      return (
                    <Button
                      onClick={handelassign}
                      disabled={assignDisabled}
                      style={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "8px",
                        border: "1px solid #122D8E",
                        background: "#FFF",
                        boxShadow: "0px 1px 8px -4px rgba(0, 0, 0, 0.12)",
                        color: "#071135",
                        textAlign: "center",
                        fontFamily: "Arial",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        opacity: assignDisabled ? 0.4 : 1,
                        cursor: assignDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      Assign
                      <img
                        src={AssignIcon}
                        alt="Assign Icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </Button>
                      );
                    })()}
                  </Col>
                </div>
              </div>

              {/* Auto-Populated Content */}
              <>
                {activeTab === "auto" && (
                  <>
                    {/* Tag Selection Section */}
                    {/* Tag Selection Section */}
                    {/* Tag Selection Section */}
                    <div style={{ position: "relative", width: "100%" }}>
                      <Select
                        mode="multiple"
                        suffixIcon={null}
                        style={{
                          width: "100%",
                          border: "none",
                          outline: "none",
                          boxShadow: "none",
                        }}
                        dropdownStyle={{ border: "none" }}
                        value={selectedGates}
                        onChange={(values) => setSelectedGates(values)}
                        notFoundContent={null}
                        tagRender={(props) => {
                          const { label, value, closable } = props;
                          const displayLabel = typeof label === "string" ? label : typeof value === "string" ? value : "";

                          const handleClose = (e) => {
                            e.preventDefault();
                            setSelectedGates((prev) =>
                              prev.filter((item) => item !== value)
                            );
                          };

                          return (
                            <Tag
                              color="#f8d7a7"
                              closable={closable}
                              onClose={handleClose}
                              style={{
                                display: "flex",
                                height: "26px",
                                padding: "4px 12px",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "7px",
                                background: "#f8d7a7",
                                color: "#091647",
                                fontFamily: "Arial",
                                fontSize: "14px",
                                fontWeight: "400",
                                borderRadius: "10px",
                                margin: "3px",
                                border: "none",
                              }}
                            >
                              {(() => {
                                const lower = displayLabel.toLowerCase();
                                // Map nok/next-of-kin to "Next-of-Kin"
                                if (lower === "nok" || lower === "next-of-kin") {
                                  return "Next-of-Kin";
                                } else if (["dob", "lsl", "ppe"].includes(lower)) {
                                  return displayLabel.toUpperCase();
                                } else if (lower === "usi number") {
                                  return "USI Number";
                                } else {
                                  return displayLabel
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ");
                                }
                              })()}
                            </Tag>
                          );
                        }}
                        className="custom-select"
                      />

                      {/* Show "No Selection" fake tag when empty */}
                      {selectedGates.length === 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "5px",
                            left: "10px",
                            color: "#A0A0A0",
                            fontSize: "14px",
                            padding: "4px 10px",
                            borderRadius: "10px",
                            background: "#F0F0F0",
                          }}
                        >
                          No Selection
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        marginBottom: "24px",
                        marginTop: "24px",
                        maxHeight: "250px",
                        // overflowY: "auto",
                      }}
                    >
                      {ENABLE_DEFAULT_GATES && (
                        <div style={{ marginBottom: "16px" }}>
                          <h4
                            style={{
                              color: "#091647",
                              fontFamily: "Arial",
                              fontSize: "12px",
                              fontWeight: "700",
                              margin: 0,
                            }}
                          >
                            Default Gates
                          </h4>
                        </div>
                      )}

                      <h4
                        style={{
                          width: "730px",
                          height: "14px",
                          color: "#091647",
                          fontFamily: "Arial",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                        }}
                      >
                        Personal Details
                      </h4>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "20px",
                          rowGap: "10px",
                          maxWidth: "750px",
                        }}
                      >
                        {[
                          "DOB",
                          "Gender",
                          "Ethnicity",
                          "Next-of-Kin",
                          "Address",
                        ].map((item) => {
                          const gateKey = getGateKeyFromLabel(item.toLowerCase());
                          const isDefault = ENABLE_DEFAULT_GATES && defaultGates.includes(gateKey);
                          const isChecked = isEditingDefaultGates 
                            ? tempSelectedAutoDefaults.includes(gateKey)
                            : isDefault || selectedGates.includes(gateKey);
                          const isDisabled = isEditingDefaultGates ? false : isDefault;
                          return (
                            <div key={item} style={{ width: "23%" }}>
                              <Checkbox
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item.toLowerCase())}
                                disabled={isDisabled}
                                style={{
                                  color: "#071135",
                                  fontFamily: "Arial",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                <span style={{ color: "#071135" }}>{item}</span>
                              </Checkbox>
                            </div>
                          );
                        })}
                      </div>

                      {/* Additional Details Section */}
                      <h4
                        style={{
                          width: "730px",
                          height: "14px",
                          color: "#091647",
                          fontFamily: "Arial",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: "700",
                          lineHeight: "normal",
                          marginTop: "20px",
                        }}
                      >
                        Additional Details
                      </h4>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "20px",
                          rowGap: "10px",
                          maxWidth: "750px",
                        }}
                      >
                        {[
                          "LSL",
                          "PPE",
                          "Travel",
                          "USI Number",
                        ].map((item) => {
                          const gateKey = getGateKeyFromLabel(item.toLowerCase());
                          const isDefault = ENABLE_DEFAULT_GATES && defaultGates.includes(gateKey);
                          const isChecked = isEditingDefaultGates 
                            ? tempSelectedAutoDefaults.includes(gateKey)
                            : isDefault || selectedGates.includes(gateKey);
                          const isDisabled = isEditingDefaultGates ? false : isDefault;
                          return (
                            <div key={item} style={{ width: "23%" }}>
                              <Checkbox
                                checked={isChecked}
                                onChange={() => handleCheckboxChange(item.toLowerCase())}
                                disabled={isDisabled}
                                style={{
                                  color: "#071135",
                                  fontFamily: "Arial",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                <span style={{ color: "#071135" }}>{item}</span>
                              </Checkbox>
                            </div>
                          );
                        })}
                      </div>
                      <div style={{ marginBottom: "24px", marginTop: "24px" }}>
                        <h4
                          style={{
                            width: "730px",
                            height: "14px",
                            color: "#091647",
                            fontFamily: "Arial",
                            fontSize: "12px",
                            fontStyle: "normal",
                            fontWeight: "700",
                            lineHeight: "normal",
                          }}
                        >
                          Advert Details
                        </h4>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "20px",
                            rowGap: "10px",
                            maxWidth: "750px",
                          }}
                        >
                          {[
                            "Project Code",
                            "Roster",
                            "Employment Type",
                            "Hard Requirments",
                            "Soft Requirments",
                            "Client Approval",
                          ].map((item) => {
                            const gateKey = getGateKeyFromLabel(item.toLowerCase());
                            const isDefault = ENABLE_DEFAULT_GATES && defaultGates.includes(gateKey);
                            const isChecked = isEditingDefaultGates 
                              ? tempSelectedAutoDefaults.includes(gateKey)
                              : isDefault || selectedGates.includes(gateKey);
                            const isDisabled = isEditingDefaultGates ? false : isDefault;
                            return (
                              <div key={item} style={{ width: "23%" }}>
                                <Checkbox
                                  checked={isChecked}
                                  onChange={() => handleCheckboxChange(item.toLowerCase())}
                                  disabled={isDisabled}
                                  style={{
                                    color: "#071135",
                                    fontFamily: "Arial",
                                    fontSize: "14px",
                                    fontWeight: "400",
                                  }}
                                >
                                  <span style={{ color: "#071135" }}>{item}</span>
                                </Checkbox>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* Recruitment Section */}
                  </>
                )}

                {/* Checkbox UI for Gates */}
              </>

              {/* Manual Creation Content */}
              {activeTab === "manual" && (
                <Row className="modal-content-row" style={{ flexWrap: "wrap" }}>
                  <Col xs={24} md={11}>
                    {false && <Dropdown
                        open={templateDropdownOpen}
                        menu={{
                          items: (() => {
                            const baseTemplates = !ENABLE_DEFAULT_GATES
                              ? allManualTemplates
                              : isEditingDefaultTemplateList
                                ? [...allManualTemplates].sort((a, b) => {
                                    const aIsDefault = defaultTemplateList.includes(a.name) ? 0 : 1;
                                    const bIsDefault = defaultTemplateList.includes(b.name) ? 0 : 1;
                                    return aIsDefault - bIsDefault;
                                  })
                                : allManualTemplates.filter((tpl) => defaultTemplateList.includes(tpl.name));
                            const displayTemplates = templateSearchVal
                              ? baseTemplates.filter((tpl) => tpl.name.toLowerCase().includes(templateSearchVal.toLowerCase()))
                              : baseTemplates;
                            return [
                              {
                                key: "search",
                                label: (
                                  <div onClick={(e) => e.stopPropagation()} style={{ padding: "6px 4px 10px 4px" }}>
                                    <Input
                                      placeholder="Search templates..."
                                      size="middle"
                                      allowClear
                                      prefix={<SearchOutlined style={{ color: "#94A3B8" }} />}
                                      onChange={(e) => {
                                        setTemplateSearchVal(e.target.value || "");
                                      }}
                                      style={{ borderRadius: "8px", height: "36px" }}
                                    />
                                  </div>
                                ),
                              },
                              {
                                key: "header",
                                type: "group",
                                label: (
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "4px 4px 2px 4px" }}>
                                    <span style={{ fontSize: "11px", fontWeight: 700, color: "#8B8FA3", letterSpacing: "0.5px", textTransform: "uppercase" }}>
                                      Templates
                                    </span>
                                    {ENABLE_DEFAULT_GATES && (
                                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }} onClick={(e) => e.stopPropagation()}>
                                        <span style={{ fontSize: "11px", fontWeight: 600, color: isEditingDefaultTemplateList ? "#122D8E" : "#8B8FA3" }}>
                                          Edit 
                                        </span>
                                        <Switch
                                          size="small"
                                          checked={isEditingDefaultTemplateList}
                                          onChange={(checked) => {
                                            if (checked) {
                                              setTempSelectedDefaults([...defaultTemplateList]);
                                              setIsEditingDefaultTemplateList(true);
                                            } else {
                                              setTempSelectedDefaults([]);
                                              setIsEditingDefaultTemplateList(false);
                                            }
                                          }}
                                          disabled={savingDefaultTemplateList}
                                        />
                                        {isEditingDefaultTemplateList && (
                                          <span
                                            onClick={() => { if (!savingDefaultTemplateList) handleSaveDefaultTemplateList(); }}
                                            style={{
                                              color: "#fff",
                                              fontSize: "11px",
                                              fontWeight: 600,
                                              cursor: savingDefaultTemplateList ? "not-allowed" : "pointer",
                                              opacity: savingDefaultTemplateList ? 0.6 : 1,
                                              background: "#122D8E",
                                              borderRadius: "4px",
                                              padding: "2px 10px",
                                            }}
                                          >
                                            {savingDefaultTemplateList ? "Saving..." : "Save"}
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                ),
                              },
                              ...(displayTemplates.length === 0
                                ? [{
                                    key: "empty",
                                    label: (
                                      <div style={{ textAlign: "center", padding: "18px 8px" }}>
                                        <span style={{ color: "#94A3B8", fontSize: "13px" }}>
                                          {isEditingDefaultTemplateList ? "No templates found" : "No default gates set. Click \"Edit Default List\" to add."}
                                        </span>
                                      </div>
                                    ),
                                    disabled: true,
                                  }]
                                : displayTemplates.map((tpl, idx) => ({
                                    key: `tpl-${idx}`,
                                    label: (
                                      <div
                                        onClick={(e) => {
                                          if (isEditingDefaultTemplateList) {
                                            e.stopPropagation();
                                            setTempSelectedDefaults((prev) =>
                                              prev.includes(tpl.name)
                                                ? prev.filter((n) => n !== tpl.name)
                                                : [...prev, tpl.name]
                                            );
                                          }
                                        }}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          gap: "16px",
                                          padding: "8px 6px",
                                          minWidth: "280px",
                                        }}
                                      >
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                          {isEditingDefaultTemplateList && (
                                            <Checkbox
                                              checked={tempSelectedDefaults.includes(tpl.name)}
                                              onClick={(e) => e.stopPropagation()}
                                              onChange={() => {
                                                setTempSelectedDefaults((prev) =>
                                                  prev.includes(tpl.name)
                                                    ? prev.filter((n) => n !== tpl.name)
                                                    : [...prev, tpl.name]
                                                );
                                              }}
                                            />
                                          )}
                                          <span style={{ fontSize: "14px", fontWeight: 500, color: "#1E293B" }}>{tpl.name}</span>
                                        </div>
                                        <div style={{
                                          width: "28px",
                                          height: "28px",
                                          borderRadius: "6px",
                                          background: tpl.type === "Calendar" ? "#EFF6FF" : tpl.type === "Pick List" ? "#EEF2FF" : "#FFF7ED",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: 0,
                                        }}>
                                          {tpl.type === "Calendar" ? (
                                            <CalendarOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                                          ) : tpl.type === "Pick List" ? (
                                            <OrderedListOutlined style={{ fontSize: "14px", color: "#4F46E5" }} />
                                          ) : (
                                            <CheckCircleOutlined style={{ fontSize: "14px", color: "#EA580C" }} />
                                          )}
                                        </div>
                                      </div>
                                    ),
                                  }))),
                            ];
                          })(),
                          onClick: ({ key }) => {
                            if (key === "header" || key === "search" || key === "loading" || key === "empty") return;
                            if (isEditingDefaultTemplateList) return;
                            const filtered = allManualTemplates.filter((tpl) => defaultTemplateList.includes(tpl.name));
                            const searchFiltered = templateSearchVal
                              ? filtered.filter((tpl) => tpl.name.toLowerCase().includes(templateSearchVal.toLowerCase()))
                              : filtered;
                            const idx = parseInt(key.replace("tpl-", ""), 10);
                            const selected = searchFiltered[idx];
                            if (selected) {
                              setName(selected.name);
                              setSelectedType(selected.type);
                              setTemplateDropdownOpen(false);
                            }
                          },
                          style: { borderRadius: "12px", padding: "10px 8px", maxHeight: "360px", overflowY: "auto" },
                        }}
                        trigger={["click"]}
                        onOpenChange={(open) => {
                          if (isEditingDefaultTemplateList && !open) return;
                          setTemplateDropdownOpen(open);
                          if (open) {
                            setTemplateSearchVal("");
                            fetchDefaultTemplateList();
                            setIsEditingDefaultTemplateList(false);
                          }
                        }}
                        overlayStyle={{ boxShadow: "0 8px 30px rgba(0,0,0,0.12)", borderRadius: "12px" }}
                      >
                        <Button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            borderRadius: "8px",
                            border: "1px solid #E2E8F0",
                            background: "#F8FAFC",
                            color: "#475569",
                            fontWeight: 600,
                            fontSize: "13px",
                            height: "38px",
                            padding: "0 16px",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                          }}
                        >
                          <AppstoreAddOutlined style={{ fontSize: "14px", color: "#1638B1" }} />
                          Select from Templates
                          <DownOutlined style={{ fontSize: "10px", color: "#94A3B8" }} />
                        </Button>
                      </Dropdown>}
                    {ENABLE_DEFAULT_GATES && !isUpdateMode && (
                      <div style={{ marginBottom: "14px" }}>
                        <Checkbox
                          checked={markAsDefaultOnCreate}
                          onChange={(e) => setMarkAsDefaultOnCreate(e.target.checked)}
                        >
                          <span style={{ fontFamily: "Arial", fontSize: "14px", fontWeight: 600, color: "#1E293B" }}>
                            Set this gate as default
                          </span>
                        </Checkbox>
                      </div>
                    )}
                    <label style={{ fontWeight: "bold", display: "block", marginBottom: "6px" }}>
                      Name
                    </label>
                    <Tooltip
                      title="You are not allowed to put more than 20 characters"
                      open={showTooltip}
                      color="red"
                    >
                      <Input
                        autoFocus
                        placeholder="Enter Name"
                        value={name}
                        onChange={handleNameChange}
                        style={{ marginBottom: "20px" }}
                      />
                    </Tooltip>

                    <div style={{ marginBottom: "20px" }}>
                      <label
                        style={{
                          fontWeight: "bold",
                          display: "block",
                          marginBottom: "10px",
                        }}
                      >
                        Type
                      </label>
                      <div
                        className="type-buttons-container"
                        style={{
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        {options.map((option) => (
                          <div
                            key={option.label}
                            style={{ position: "relative" }}
                          >
                            {previousType === "Calendar" &&
                            option.label === "Calendar" ? (
                              <Tooltip
                                title="A calendar date, cannot be edited on this screen."
                                placement="top"
                                overlayStyle={{ maxWidth: 200 }}
                                arrow={false}
                              >
                                <div style={{ display: "inline-block" }}>
                                  <Button
                                    type={
                                      selectedType === option.label
                                        ? "primary"
                                        : "default"
                                    }
                                    disabled
                                    ref={typeRef}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                      borderRadius: "12px",
                                      padding: "23px 20px",
                                      minWidth: "120px",
                                      textAlign: "center",
                                      opacity: 0.5,
                                      cursor: "not-allowed",
                                      border:
                                        selectedType === option.label
                                          ? "2px solid #122D8E"
                                          : "1px solid #122D8E",
                                      backgroundColor:
                                        selectedType === option.label
                                          ? "#F7F9FF"
                                          : "transparent",
                                      color: "#122D8E",
                                      fontWeight: 600,
                                      position: "relative",
                                    }}
                                  >
                                    {option.icon} {option.label}
                                  </Button>
                                </div>
                              </Tooltip>
                            ) : (
                              <Button
                                type={
                                  selectedType === option.label
                                    ? "primary"
                                    : "default"
                                }
                                onClick={() => handleButtonClick(option.label)}
                                ref={typeRef}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                  borderRadius: "12px",
                                  padding: "23px 20px",
                                  minWidth: "120px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  border:
                                    selectedType === option.label
                                      ? "2px solid #122D8E"
                                      : "1px solid #122D8E",
                                  backgroundColor:
                                    selectedType === option.label
                                      ? "#F7F9FF"
                                      : "transparent",
                                  color: "#122D8E",
                                  fontWeight: 600,
                                  position: "relative",
                                }}
                              >
                                {option.icon} {option.label}
                              </Button>
                            )}

                            {/* Pencil Icon (only on selected) */}
                            {selectedType === "Pick List" &&
                              selectedType === option.label && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "-6px",
                                    backgroundColor: "white",
                                    border: "1px solid #122D8E",
                                    borderRadius: "50%",
                                    width: "24px",
                                    height: "24px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  <EditOutlined
                                    style={{
                                      fontSize: "12px",
                                      color: "#122D8E",
                                    }}
                                  />
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                      {popoverVisible && (
                        <div
                          style={{
                            width: "307.5px",
                            height: "182.567px",
                            position: "absolute",
                            // left: "5px",
                            bottom: "30px",
                            // bottom: "-0.167px",
                            zIndex: 9999,

                            // backgroundColor: "white",
                          }}
                        >
                          {" "}
                          {/* Adjust width as needed */}
                          <DatePicker
                            className="createGateDatePicker"
                            open={popoverVisible}
                            onOpenChange={() => {
                              popoverVisible
                                ? setPopoverVisible(false)
                                : setPopoverVisible(true);
                            }}
                            onChange={(date) => handleDateClick(date)}
                            value={selectedDate}
                            // disabledDate={(current) =>
                            //   current && current.isBefore(tomorrow, "day")
                            // }
                            style={{ width: "100%", border: "2px solid red" }}
                          />
                        </div>
                      )}
                      {PopoverVisiblePickList && (
                        <Dropdown
                          open={dropdownVisible}
                          onOpenChange={setDropdownVisible}
                          trigger={["click"]}
                          dropdownRender={(menu) => (
                            <div
                              className="custom-dropdown"
                              style={{
                                padding: 16,
                                width: 350,
                                background: "#fff",
                                borderRadius: 6,
                                marginRight: "20px",
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                              }}
                            >
                              <Row
                                justify="space-between"
                                align="middle"
                                style={{ marginBottom: 16 }}
                              >
                                <Typography.Text
                                  strong
                                  style={{ fontSize: 14 }}
                                >
                                  Pick List Values
                                </Typography.Text>

                                <InputNumber
                                  min={1}
                                  max={10}
                                  value={
                                    values.length ? values.length : numValues
                                  }
                                  onChange={(value) => {
                                    const newValue = Math.min(value || 1, 10); // Fallback to 1 if value is null or undefined
                                    setNumValues(newValue); // Now track actual user input
                                    setValues((prev) => {
                                      const newValues = [
                                        ...prev.slice(0, newValue),
                                      ];
                                      while (newValues.length < newValue)
                                        newValues.push("");
                                      return newValues;
                                    });
                                  }}
                                  style={{ width: 80 }}
                                  // Disable typing but allow increment/decrement
                                  formatter={(value) =>
                                    value.replace(/\D/g, "")
                                  } // Only allow numbers
                                  parser={(value) => value.replace(/\D/g, "")} // Parse value as numbers only
                                  controls={true} // Show increment and decrement arrows
                                  onFocus={(e) => e.target.blur()}
                                />
                              </Row>

                              {/* Input Fields Grid */}
                              <Row gutter={[12, 12]}>
                                {values.map((val, index) => (
                                  <Col span={12} key={index}>
                                    <Input
                                      placeholder={`Value ${index + 1}`}
                                      value={val}
                                      onChange={(e) =>
                                        handleChangePickLists(
                                          index,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Col>
                                ))}
                              </Row>

                              {/* Buttons */}
                              <Row
                                justify="space-between"
                                style={{ marginTop: 16 }}
                              >
                                <Button
                                  onClick={() => {
                                    // setValues(Array(numValues).fill("")); // Reset all input fields
                                    setDropdownVisible(false); // Close dropdown
                                  }}
                                  style={{
                                    marginRight: "10px",
                                    display: "flex",
                                    padding: "12px 30px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                    flex: "1 0 0",
                                    borderRadius: "8px",
                                    border: "1px solid #122D8E",
                                    color: "#122D8E",
                                    textAlign: "center",
                                    fontFamily: "Arial",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 700,
                                    lineHeight: "normal",
                                    background: "transparent",
                                  }}
                                >
                                  Cancel
                                </Button>

                                <Button
                                  type="primary"
                                  style={{
                                    display: "flex",
                                    padding: "12px 30px",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                    flex: "1 0 0",
                                    borderRadius: "8px",
                                    background: "#F9CF66",
                                    borderColor: "#F9CF66",
                                    color: "#071135",
                                    textAlign: "center",
                                    fontFamily: "Arial",
                                    fontSize: "14px",
                                    fontStyle: "normal",
                                    fontWeight: 700,
                                    lineHeight: "normal",
                                  }}
                                  onClick={() => setDropdownVisible(false)}
                                >
                                  Done
                                </Button>
                              </Row>
                            </div>
                          )}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </Dropdown>
                      )}
                    </div>

                    {/* <label style={{ fontWeight: "bold", display: "block" }}>
                      Category
                    </label> */}
                    {/* <Select
                      placeholder="Choose Category"
                      style={{ width: "100%", marginTop: "8px" }}
                      onChange={handleCategoryChange}
                    >
                      <Select.Option value="personal details">
                        Personal Details
                      </Select.Option>
                      <Select.Option value="recruitment">
                        Recruitment
                      </Select.Option>
                      <Select.Option value="other details">
                        Other Details
                      </Select.Option>
                    </Select> */}
                  </Col>

                  {/* Preview Section */}
                  <Col
                    xs={24}
                    md={12}
                    className="preview-section"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginTop: "16px",
                    }}
                  >
                    <div
                      className="preview-box"
                      style={{
                        border: "1px solid #D9D9D9",
                        padding: "30px",
                        borderRadius: "12px",
                        background: "#fff",
                        width: "355px",
                        height: "350px",
                        maxWidth: "300px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        textAlign: "center",
                      }}
                    >
                      <h4 style={{ marginBottom: "12px", color: "#333" }}>
                        PREVIEW
                      </h4>
                      <div
                        style={{
                          border: "1px solid #eee",
                          padding: "12px",
                          borderRadius: "12px",
                          background: "#fff",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
                          width: "100%",
                          // maxWidth: "200px",
                        }}
                      >
                        {/* Label with Icon */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            marginBottom: "8px",
                            background: "#fff",
                            borderRadius: "6px",
                            padding: "6px",
                            border: "1px solid #ddd",
                            fontWeight: "bold",
                          }}
                        >
                          <MenuOutlined
                            style={{ fontSize: "16px", color: "#666" }}
                          />
                          <span style={{ flex: 1 }}>{name}</span>
                        </div>

                        {/* Input with Red Icon Dropdown */}
                        {/* Dynamic Field Rendering */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center", // Centers content horizontally
                            // border: "1px solid #ddd",
                            borderRadius: "6px",
                            overflow: "hidden",

                            width: "100%",
                            maxHeight: "40px",
                          }}
                        >
                          {selectedType === "Calendar" && (
                            <h3
                              style={{
                                textAlign: "center", // Ensures text is centered
                                marginTop: 20, // Removes default margin
                              }}
                            >
                              <p>{selectedDate.format("DD MMM YYYY")}</p>
                            </h3>
                          )}

                          {selectedType === "Pick List" && (
                            <Select
                              // open={true}
                              style={{ width: 300 }}
                              placeholder="Choose Value"
                              dropdownStyle={{ maxHeight: "none " }}
                              // onDropdownVisibleChange={() => {}}
                            >
                              {values.map((value, index) =>
                                value !== "" ? (
                                  <Option key={index} value={value}>
                                    {value}
                                  </Option>
                                ) : null
                              )}
                            </Select>
                          )}

                          {selectedType === "Yes/No" && (
                            <Select
                              value={YesNoValue}
                              onChange={(value) => setYesNoValue(value)}
                              style={{
                                width: "100%",
                                borderRadius: "8px",
                                background: "#F8FAFC",
                                // padding: "6px 12px",
                              }}
                            >
                              <Select.Option value="NO">
                                <img
                                  src={NoIcon}
                                  style={{
                                    height: "20px",
                                    widht: "20px",
                                    marginRight: "5px",
                                  }}
                                />
                                No
                              </Select.Option>
                              <Select.Option value="WIP">
                                <img
                                  src={NAIcon}
                                  style={{
                                    height: "20px",
                                    widht: "20px",
                                    marginRight: "5px",
                                  }}
                                />
                                WIP
                              </Select.Option>

                              <Select.Option value="YES">
                                <img
                                  src={YesIcon}
                                  style={{
                                    height: "20px",
                                    widht: "20px",
                                    marginRight: "5px",
                                  }}
                                />
                                Yes
                              </Select.Option>
                            </Select>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </Modal>

            <Modal
              className="candidateDeleteModal"
              centered
              width={392}
              getContainer={document.body}
              onCancel={() => {
                if (!savingDefaultGates) setDefaultGateConfirmType(null);
              }}
              open={!!defaultGateConfirmType}
              footer={null}
              title="Apply Edit?"
            >
              <Row className="header">
                <Col>
                  <p className="desc">
                    Existing jobs will keep their current gates and won't be affected.
                  </p>
                </Col>
              </Row>

              <Row align="middle" gutter={16} justify="end">
                <Col>
                  <Button
                    className="confirmBtn"
                    onClick={handleConfirmDefaultGateAction}
                    loading={savingDefaultGates}
                    disabled={!autoDefaultGatesHasChanges}
                    style={{
                      opacity: !autoDefaultGatesHasChanges ? 0.5 : 1,
                      cursor: !autoDefaultGatesHasChanges ? "not-allowed" : "pointer",
                    }}
                  >
                    Confirm
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="cancelBtn"
                    onClick={() => setDefaultGateConfirmType(null)}
                    disabled={savingDefaultGates}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Modal>

            {/* Manual Default Gate Modal */}
            <Modal
              className="candidateDeleteModal"
              centered
              width={480}
              getContainer={document.body}
              onCancel={() => {
                if (!savingDefaultTemplateList) {
                  closeManualDefaultModal();
                }
              }}
              open={manualDefaultModalOpen}
              footer={null}
              title="Default Gate"
            >
              <Row className="header">
                <Col span={24}>
                  <p className="desc" style={{ marginBottom: "16px" }}>
                    Select the gates you want to set as default.
                  </p>
                  {allManualTemplates.length === 0 ? (
                    <p style={{ color: "#94A3B8", fontSize: "13px", textAlign: "center", padding: "12px 0" }}>
                      No gates available.
                    </p>
                  ) : (
                    <div style={{ maxHeight: "280px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
                      {[...allManualTemplates]
                        .sort((a, b) => {
                          const aIsDefault = defaultTemplateList.includes(a.name) ? 0 : 1;
                          const bIsDefault = defaultTemplateList.includes(b.name) ? 0 : 1;
                          if (aIsDefault !== bIsDefault) {
                            return aIsDefault - bIsDefault;
                          }
                          return (a.name || "").localeCompare(b.name || "", undefined, {
                            sensitivity: "base",
                          });
                        })
                        .map((tpl) => (
                        <div
                          key={tpl.name}
                          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 4px", borderBottom: "1px solid #F1F5F9" }}
                        >
                          <Checkbox
                            checked={manualDefaultTempSelected.includes(tpl.name)}
                            onChange={() => {
                              setManualDefaultTempSelected((prev) =>
                                prev.includes(tpl.name)
                                  ? prev.filter((n) => n !== tpl.name)
                                  : [...prev, tpl.name]
                              );
                            }}
                          >
                            <span style={{ fontFamily: "Arial", fontSize: "14px", fontWeight: 500, color: "#1E293B" }}>{tpl.name}</span>
                          </Checkbox>
                          <div style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "6px",
                            background: tpl.type === "Calendar" ? "#EFF6FF" : tpl.type === "Pick List" ? "#EEF2FF" : "#FFF7ED",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}>
                            {tpl.type === "Calendar" ? (
                              <CalendarOutlined style={{ fontSize: "14px", color: "#2563EB" }} />
                            ) : tpl.type === "Pick List" ? (
                              <OrderedListOutlined style={{ fontSize: "14px", color: "#4F46E5" }} />
                            ) : (
                              <CheckCircleOutlined style={{ fontSize: "14px", color: "#EA580C" }} />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
              <Row align="middle" gutter={16} justify="end" style={{ marginTop: "16px" }}>
                <Col>
                  <Button
                    className="confirmBtn"
                    onClick={handleSaveManualDefaultModal}
                    loading={savingDefaultTemplateList}
                    disabled={
                      manualDefaultTempSelected.length === defaultTemplateList.length &&
                      manualDefaultTempSelected.every((n) => defaultTemplateList.includes(n))
                    }
                    style={{
                      opacity:
                        manualDefaultTempSelected.length === defaultTemplateList.length &&
                        manualDefaultTempSelected.every((n) => defaultTemplateList.includes(n))
                          ? 0.5
                          : 1,
                      cursor:
                        manualDefaultTempSelected.length === defaultTemplateList.length &&
                        manualDefaultTempSelected.every((n) => defaultTemplateList.includes(n))
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Save
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="cancelBtn"
                    onClick={closeManualDefaultModal}
                    disabled={savingDefaultTemplateList}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Modal>
          </div>
        </div>

        {loadingTable ? (
          <div className="loaderContainer">
            <img src={LoaderGif} alt="Loading..." />
          </div>
        ) : data.length === 0 || columns.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              color: "#071135",
              fontFamily: "Arial",
              // marginBottom: "8px",
              marginTop: "18%",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
            }}
          >
            <div className="noDataContainer">
              <img src={NoElement} alt="Loading..." />
            </div>
            <h2>No Data</h2>
          </div>
        ) : (
          <div
            className="custom-scrollbar"
            style={{
              maxHeight: "84%",
              overflowX: "auto",
              overflowY: "auto",
              position: "relative",
            }}
          >
            <div
              style={{
                minWidth: columns.length >= 6 ? "max-content" : undefined,
                width: columns.length < 6 ? "75%" : undefined,
              }}
            >
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={(event) => {
                  console.log("🎯 Drag started:", event);
                }}
                onDragEnd={onDragEnd}
                onDragOver={(event) => {
                  console.log("🔄 Drag over:", event);
                }}
              >
                <SortableContext
                  items={columns
                    .filter(
                      (col) =>
                        col.key !== "details" && col.key !== "campaign-advert"
                    )
                    .map((col) => col.dataIndex)}
                  strategy={horizontalListSortingStrategy}
                >
                  <Table
                    className="custom-table"
                    dataSource={data.filter(
                      (row) => !hideRow.includes(row.jobId)
                    )}
                    columns={columns.map((col) => ({
                      ...col,
                      minWidth: col.minWidth || 100,

                      title: (
                        <span
                          style={{
                            display: "flex",
                            // position: "fixed",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            cursor: noDragKeys.includes(col.key)
                              ? "default"
                              : "pointer",
                          }}
                          title={
                            noDragKeys.includes(col.key) ? "" : "Tap to Edit"
                          }
                        >
                          {noDragKeys.includes(col.key) ? (
                            col.title
                          ) : (
                            <>
                              <SortableColumn
                                title={col.title}
                                columnKey={col.key}
                              />

                              {/* {!noUnderlineKeys.includes(col.key) && ( */}
                              <EditOutlined
                                onClick={() => {
                                  setadvertIds([]);
                                  setOldName(col.key);
                                  setName(col.key);
                                  setSelectedGates([col.key]);
                                  setIsUpdateMode(true);
                                  handelAdvertofGates(col?.key);

                                  if (noUnderlineKeys?.includes(col?.key)) {
                                    setActiveTab("auto");
                                    handleprefilled(col.key);
                                    handleAssignModalOpen();
                                  } else {
                                    setIsAddGateModalOpen(true);
                                    setActiveTab("manual");
                                    setActiveAssign(true);
                                    handleprefilled(col.key);

                                    setisManual(true);
                                  }
                                }}
                                style={{
                                  fontSize: "14px",
                                  color: "#595959",
                                  marginTop: "2px",
                                }}
                              />
                              {/* )} */}
                            </>
                          )}
                        </span>
                      ),
                    }))}
                    rowKey="key"
                    pagination={false}
                    scroll={false}
                    // sticky={true}
                    onRow={(record) => ({
                      onClick: () => {
                        setrowID(record?.gateId);
                        setrowuserName(record?.userName);
                      },
                    })}
                  />
                </SortableContext>
              </DndContext>
            </div>
          </div>
        )}
        <div>
          {data.length != 0 && columns.length != 0 && (
            <MobilzationPagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              total={totalRecord}
              itemPerPage={10}
              selectedAdverts ={selectedAdverts}
              setIsFilterUsing={setIsFilterUsingState}
            />
          )}
        </div>
      </div>
    </SubLayout>
  );
}

export default MobilisationManagement;
